var Zt = (s, t, e) => {
  if (!t.has(s))
    throw TypeError("Cannot " + e);
};
var B = (s, t, e) => (Zt(s, t, "read from private field"), e ? e.call(s) : t.get(s)), Y = (s, t, e) => {
  if (t.has(s))
    throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(s) : t.set(s, e);
}, rt = (s, t, e, n) => (Zt(s, t, "write to private field"), n ? n.call(s, e) : t.set(s, e), e);
var lt = (s, t, e) => (Zt(s, t, "access private method"), e);
import bs, { ref as h, computed as x, provide as ot, watch as O, defineComponent as k, onBeforeUnmount as re, inject as F, shallowRef as We, onBeforeMount as ae, reactive as je, onUnmounted as ys, onMounted as j, nextTick as kt, readonly as xs, toRef as Cs, unref as ut, getCurrentScope as $s, onScopeDispose as ws, shallowReadonly as ct, toRefs as ks } from "vue";
import ge from "inputmask";
function d(s, t, e, n, o, a, r, i) {
  var l = typeof s == "function" ? s.options : s;
  t && (l.render = t, l.staticRenderFns = e, l._compiled = !0), n && (l.functional = !0), a && (l._scopeId = "data-v-" + a);
  var c;
  if (r ? (c = function(p) {
    p = p || // cached call
    this.$vnode && this.$vnode.ssrContext || // stateful
    this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !p && typeof __VUE_SSR_CONTEXT__ < "u" && (p = __VUE_SSR_CONTEXT__), o && o.call(this, p), p && p._registeredComponents && p._registeredComponents.add(r);
  }, l._ssrRegister = c) : o && (c = i ? function() {
    o.call(
      this,
      (l.functional ? this.parent : this).$root.$options.shadowRoot
    );
  } : o), c)
    if (l.functional) {
      l._injectStyles = c;
      var u = l.render;
      l.render = function(f, v) {
        return c.call(v), u(f, v);
      };
    } else {
      var _ = l.beforeCreate;
      l.beforeCreate = _ ? [].concat(_, c) : [c];
    }
  return {
    exports: s,
    options: l
  };
}
const Ds = {
  name: "DsAccordion",
  props: {
    value: {
      type: Number,
      default: null
    },
    /** @deprecated В новой версии разделитель будет на уровне компонента DsExpand */
    divided: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["input"],
  setup(s, { emit: t }) {
    const e = h({
      count: 0,
      active: s.value,
      divided: x(() => s.divided)
    });
    return ot("accordion", e), O(
      () => s.value,
      (n) => {
        e.value.active = n;
      }
    ), O(
      () => e.value.active,
      (n) => {
        t("input", n);
      }
    ), {
      accordion: e
    };
  }
};
var Ss = function() {
  var t = this, e = t._self._c;
  return e("ul", { staticClass: "ds-accordion" }, [t._t("default")], 2);
}, Ts = [], Rs = /* @__PURE__ */ d(
  Ds,
  Ss,
  Ts,
  !1,
  null,
  "34d3a05b",
  null,
  null
);
const Ku = Rs.exports;
const Bs = {
  name: "DsIcon",
  props: {
    name: {
      type: String,
      required: !0
    },
    color: {
      type: String,
      default: "icon-main"
    }
  },
  computed: {
    iconsSrc() {
      return `https://static.cdn-kaspi.kz/ds/core-icons/${this.name}.svg`;
    },
    sizeClass() {
      const s = this.name.match(/\d+$/g);
      return `icon-box-${s ? s[0] : "400"}`;
    }
  }
};
var Os = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "ds-icon", class: [t.color, t.sizeClass], style: { maskImage: `url(${t.iconsSrc})` }, on: { click: function(n) {
    return t.$emit("click", n);
  } } });
}, As = [], Is = /* @__PURE__ */ d(
  Bs,
  Os,
  As,
  !1,
  null,
  null,
  null,
  null
);
const R = Is.exports, Ht = {
  tag: {
    type: String,
    default: "div"
  }
}, Ps = {
  name: "DsContainer",
  props: {
    ...Ht
  }
};
var Es = function() {
  var t = this, e = t._self._c;
  return e(t.tag, { tag: "component", staticClass: "ds-container" }, [t._t("default")], 2);
}, Ls = [], Fs = /* @__PURE__ */ d(
  Ps,
  Es,
  Ls,
  !1,
  null,
  null,
  null,
  null
);
const S = Fs.exports;
const Ms = {
  name: "DsFadeTransition",
  props: {
    mode: {
      type: String,
      default: null
    }
  }
};
var zs = function() {
  var t = this, e = t._self._c;
  return e("Transition", { staticClass: "ds-fade-transition", attrs: { name: "fade", mode: t.mode } }, [t._t("default")], 2);
}, Hs = [], Ns = /* @__PURE__ */ d(
  Ms,
  zs,
  Hs,
  !1,
  null,
  null,
  null,
  null
);
const ie = Ns.exports, Vs = {
  name: "DsExpandTransition",
  props: {
    duration: {
      type: [String, Number],
      default: "300"
    }
  },
  computed: {
    hooks() {
      return {
        beforeEnter: this.beforeEnter,
        enter: this.enter,
        afterEnter: this.afterEnter,
        beforeLeave: this.beforeLeave,
        leave: this.leave,
        afterLeave: this.afterLeave
      };
    }
  },
  methods: {
    beforeEnter(s) {
      this.setDuration(s), requestAnimationFrame(() => {
        s.style.height || (s.style.height = "0px"), s.style.display = null;
      });
    },
    enter(s) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          s.style.height = `${s.scrollHeight}px`;
        });
      });
    },
    afterEnter(s) {
      this.cleanUpDuration(s), s.style.height = null;
    },
    beforeLeave(s) {
      this.setDuration(s), requestAnimationFrame(() => {
        s.style.height || (s.style.height = `${s.offsetHeight}px`);
      });
    },
    leave(s) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          s.style.height = "0px";
        });
      });
    },
    afterLeave(s) {
      this.cleanUpDuration(s);
    },
    setDuration(s) {
      s.style.transition = `height ${this.duration}ms ease-out`;
    },
    cleanUpDuration(s) {
      s.style.transitionDuration = "";
    }
  }
};
var Ws = function() {
  var t = this, e = t._self._c;
  return e("transition", t._g(t._b({ attrs: { name: "expand" } }, "transition", t.$attrs, !1), t.hooks), [t._t("default")], 2);
}, js = [], Us = /* @__PURE__ */ d(
  Vs,
  Ws,
  js,
  !1,
  null,
  null,
  null,
  null
);
const Ue = Us.exports;
const Ys = {
  props: {
    direction: {
      type: String,
      default: "left"
    }
  }
};
var qs = function() {
  var t = this, e = t._self._c;
  return e("Transition", { attrs: { name: "ds-slide" } }, [t._t("default")], 2);
}, Zs = [], Xs = /* @__PURE__ */ d(
  Ys,
  qs,
  Zs,
  !1,
  null,
  null,
  null,
  null
);
const Ju = Xs.exports, Ye = Symbol("transition-private-data"), qe = Symbol("transition-public-data"), Gs = /* @__PURE__ */ k({
  __name: "DsPageTransition",
  props: {
    name: { default: "fade" },
    scrollOffset: { default: 0 }
  },
  emits: ["before-enter", "enter", "after-enter", "before-leave", "leave", "after-leave"],
  setup(s, { emit: t }) {
    const e = s, n = h(null), o = {
      target: n
    };
    ot(Ye, o);
    function a(_) {
      n.value = _, t("before-enter", _);
    }
    function r(_) {
      t("enter", _);
    }
    function i(_) {
      t("after-enter", _);
    }
    function l(_) {
      t("before-leave", _);
    }
    function c(_) {
      _.style.top = `-${e.scrollOffset - _.getBoundingClientRect().top}px`, t("leave", _);
    }
    function u(_) {
      t("after-leave", _);
    }
    return { __sfc: !0, target: n, props: e, provideData: o, emit: t, onBeforeEnter: a, onEnter: r, onAfterEnter: i, onBeforeLeave: l, onLeave: c, onAfterLeave: u };
  }
});
var Ks = function() {
  var t = this, e = t._self._c, n = t._self._setupProxy;
  return e("div", { staticClass: "demo", attrs: { id: "ds-transition" } }, [e("div", { staticClass: "ds-transition-wrapper" }, [e("transition", { attrs: { name: t.name, css: t.name !== "none" }, on: { "before-enter": n.onBeforeEnter, enter: n.onEnter, "after-enter": n.onAfterEnter, "before-leave": n.onBeforeLeave, leave: n.onLeave, "after-leave": n.onAfterLeave } }, [t._t("default")], 2)], 1)]);
}, Js = [], Qs = /* @__PURE__ */ d(
  Gs,
  Ks,
  Js,
  !1,
  null,
  null,
  null,
  null
);
const Qu = Qs.exports, tn = typeof window < "u", At = tn && window.navigator.userAgent.toLowerCase(), le = At && At.indexOf("android") > 0, yt = At && /iphone|ipad|ipod|ios/.test(At), en = "is_mobile_app";
document.cookie.indexOf(en);
const be = Object.freeze({
  undefined: "undefined",
  Android: "android",
  IOS: "ios"
}), sn = () => le ? be.Android : be.IOS, nn = () => {
  document.documentElement.setAttribute("data-os", sn());
};
function td(s) {
  const t = h(0), e = h("slide-left"), n = "slide-left";
  let o = "none", a = !1;
  function r() {
    o = "slide-right";
  }
  function i() {
    a = !0;
  }
  return window.addEventListener("popstate", i), s.beforeEach((c, u, _) => {
    t.value = window.scrollY, setTimeout(() => {
      _();
    });
  }), s.afterEach((c, u) => {
    e.value = a ? o : n, o = yt ? "none" : "slide-right", a = !1;
  }), ot(qe, { setBackAnimation: r }), re(() => {
    window.removeEventListener("popstate", i);
  }), {
    transition: e,
    scrollOffset: t,
    setBackAnimation: r
  };
}
const on = {
  name: "DsAccordionItem",
  components: {
    DsContainer: S,
    DsIcon: R,
    DsExpandTransition: Ue
  },
  props: {
    title: {
      type: String,
      default: ""
    }
  },
  setup() {
    const s = F("accordion");
    if (!s)
      return console.warn("Need to wrap with Accordion component"), {
        isValid: !1
      };
    const t = We(null), e = x(() => t.value === s.value.active);
    function n() {
      s.value.active = e.value ? null : t.value;
    }
    return ae(() => {
      s.value.count += 1, t.value = s.value.count;
    }), {
      isValid: !0,
      divided: x(() => s.value.divided),
      onTrigger: n,
      isVisible: e
    };
  }
};
var rn = function() {
  var t = this, e = t._self._c;
  return t.isValid ? e("li", { staticClass: "ds-accordion__item", class: {
    "ds-accordion__item--divided": t.divided
  } }, [e("DsContainer", { staticClass: "ds-accordion__head", class: {
    "ds-accordion__head--active title-600-heavy": t.isVisible,
    "body-500": !t.isVisible
  }, nativeOn: { click: function(n) {
    return t.onTrigger.apply(null, arguments);
  } } }, [t._t("title", function() {
    return [t._v(" " + t._s(t.title) + " ")];
  }), t._t("append-icon", function() {
    return [e("div", { staticClass: "ds-accordion__head_icon" }, [e("DsIcon", { attrs: { name: "system/chevron-down-400", color: "icon-light" } })], 1)];
  }, { expanded: t.isVisible })], 2), e("DsExpandTransition", [t.isVisible ? e("DsContainer", { staticClass: "ds-accordion__content_wrapper" }, [e("article", { staticClass: "ds-accordion__content body-500" }, [t._t("default")], 2)]) : t._e()], 1)], 1) : t._e();
}, an = [], ln = /* @__PURE__ */ d(
  on,
  rn,
  an,
  !1,
  null,
  "7385ee3a",
  null,
  null
);
const ed = ln.exports, Xt = "ds-overflow-hidden";
function Ze() {
  const s = h(0), t = h(!1);
  if (t.value)
    return;
  function e() {
    t.value = document.body.classList.contains(Xt), !t.value && (yt && (s.value = window.scrollY, document.body.style.setProperty("margin-top", -s.value + "px")), document.body.classList.add(Xt));
  }
  function n() {
    t.value || (document.body.classList.remove(Xt), yt && (document.body.style.removeProperty("margin-top"), window.scrollTo(0, s.value)));
  }
  return {
    setOverflowHidden: e,
    unsetOverflowHidden: n
  };
}
const cn = {
  name: "DsPortal",
  abstract: !0,
  props: {
    to: {
      type: String,
      default: "body"
    }
  },
  render() {
    try {
      return this.$slots.default[0];
    } catch {
      throw new Error("[DS]: can only render one child component");
    }
  },
  inject: {
    transition: {
      from: Ye,
      default: null
    }
  },
  computed: {
    root() {
      var s, t;
      return (t = (s = this.transition) == null ? void 0 : s.target) == null ? void 0 : t.value;
    }
  },
  watch: {
    root: {
      handler(s) {
        this.insertElement(s);
      },
      deep: !0
    }
  },
  methods: {
    insertElement(s) {
      var e;
      if (!s || !this.to || !((e = this.$slots.default[0]) != null && e.elm))
        return;
      const t = s.querySelector(this.to);
      t && t.appendChild(this.$slots.default[0].elm);
    }
  },
  destroyed() {
    const { $el: s } = this;
    s && s.parentNode && s.parentNode.removeChild(s);
  }
}, un = null, dn = null;
var _n = /* @__PURE__ */ d(
  cn,
  un,
  dn,
  !1,
  null,
  null,
  null,
  null
);
const ce = _n.exports;
const fn = {
  name: "DsOverlay",
  components: { DsFadeTransition: ie, DsPortal: ce },
  props: {
    visible: {
      type: Boolean,
      default: !1
    },
    opacity: {
      type: [String, Number],
      default: 80,
      validator: (s) => [40, 60, 80].includes(Number(s))
    }
  },
  setup() {
    const { setOverflowHidden: s, unsetOverflowHidden: t } = Ze();
    return { setOverflowHidden: s, unsetOverflowHidden: t };
  },
  watch: {
    visible: {
      handler(s) {
        s ? this.setOverflowHidden() : this.unsetOverflowHidden();
      },
      immediate: !0
    }
  },
  beforeDestroy() {
    this.unsetOverflowHidden();
  }
};
var pn = function() {
  var t = this, e = t._self._c;
  return e("DsPortal", { attrs: { to: ".ds-layout__body" } }, [e("DsFadeTransition", [e("div", { directives: [{ name: "show", rawName: "v-show", value: t.visible, expression: "visible" }], staticClass: "ds-overlay", class: [`ds-overlay--opacity-${t.opacity}`], on: { click: function(n) {
    return n.target !== n.currentTarget ? null : t.$emit("click:overlay", n);
  } } }, [t._t("default")], 2)])], 1);
}, vn = [], mn = /* @__PURE__ */ d(
  fn,
  pn,
  vn,
  !1,
  null,
  null,
  null,
  null
);
const ue = mn.exports, hn = /* @__PURE__ */ k({
  __name: "DsAlert",
  props: {
    visible: { type: Boolean, default: !1 },
    layout: { default: "default" }
  },
  emits: ["click:overlay"],
  setup(s) {
    return { __sfc: !0, DsOverlay: ue, DsContainer: S };
  }
});
var gn = function() {
  var t = this, e = t._self._c, n = t._self._setupProxy;
  return e(n.DsOverlay, { attrs: { visible: t.visible }, on: { "click:overlay": function(o) {
    return t.$emit("click:overlay", o);
  } } }, [e("div", { staticClass: "ds-alert__wrapper" }, [e("div", { staticClass: "ds-alert" }, [e(n.DsContainer, { staticClass: "ds-alert__info" }, [e("div", { staticClass: "ds-alert__title title-500-heavy" }, [t._t("title")], 2), t.$slots.description ? e("div", { staticClass: "ds-alert__description body-400" }, [t._t("description")], 2) : t._e()]), e("div", { staticClass: "ds-alert__action", class: `ds-alert__action--${t.layout}` }, [t._t("default")], 2)], 1)])]);
}, bn = [], yn = /* @__PURE__ */ d(
  hn,
  gn,
  bn,
  !1,
  null,
  null,
  null,
  null
);
const sd = yn.exports;
var Xe = typeof window < "u", xn = () => Xe ? window.innerWidth : 0, Cn = () => Xe ? window.innerHeight : 0, $n = (s) => s ?? xn(), wn = (s) => s ?? Cn(), kn = (s) => ({ width: $n(s == null ? void 0 : s.width), height: wn(s == null ? void 0 : s.height) }), Dn = (s) => {
  let t = 0, e = s(), n = je(kn()), o = ({ width: i, height: l }) => {
    n.width = i, n.height = l;
  };
  e.addObserver("composition-api", o);
  let a = () => {
    ++t;
  }, r = () => {
    t = Math.max(t - 1, 0);
  };
  return () => (t === 0 && e.subscribe().dispatch(), a(), ys(() => {
    r(), t === 0 && e.unsubscribe();
  }), { width: x(() => n.width), height: x(() => n.height) });
}, K, at, Ct, J, Q, $t, Qt, wt, te, zt, Ge, Ve, Sn = (Ve = class {
  constructor(s) {
    Y(this, $t);
    Y(this, wt);
    Y(this, zt);
    Y(this, K, /* @__PURE__ */ new Map());
    Y(this, at, void 0);
    Y(this, Ct, void 0);
    Y(this, J, !1);
    Y(this, Q, void 0);
    let { delay: t = 33 } = s ?? {};
    rt(this, at, t), rt(this, Q, lt(this, zt, Ge).bind(this));
  }
  addObserver(s, t) {
    return B(this, K).set(s, t), t(lt(this, $t, Qt).call(this)), this;
  }
  deleteObserver(s) {
    return B(this, K).delete(s), this;
  }
  deleteObservers() {
    return B(this, K).clear(), this;
  }
  notifyObservers(s) {
    return B(this, K).forEach((t) => {
      t(s);
    }), this;
  }
  subscribe() {
    return typeof window > "u" ? this : B(this, J) ? this : (window.addEventListener("resize", B(this, Q)), window.addEventListener("orientationchange", B(this, Q)), rt(this, J, !0), this);
  }
  unsubscribe() {
    return B(this, J) ? (window.removeEventListener("resize", B(this, Q)), window.removeEventListener("orientationchange", B(this, Q)), rt(this, J, !1), this) : this;
  }
  setDelay(s) {
    return rt(this, at, s), this;
  }
  info() {
    return { delay: B(this, at), subscribed: B(this, J), observersCount: B(this, K).size };
  }
  dispatch() {
    return lt(this, wt, te).call(this), this;
  }
}, K = new WeakMap(), at = new WeakMap(), Ct = new WeakMap(), J = new WeakMap(), Q = new WeakMap(), $t = new WeakSet(), Qt = function() {
  return typeof window > "u" ? { width: 0, height: 0 } : { width: window.innerWidth, height: window.innerHeight };
}, wt = new WeakSet(), te = function() {
  let s = lt(this, $t, Qt).call(this);
  this.notifyObservers(s);
}, zt = new WeakSet(), Ge = function() {
  clearTimeout(B(this, Ct)), window.setTimeout(() => {
  }, 1), rt(this, Ct, window.setTimeout(() => {
    lt(this, wt, te).call(this);
  }, B(this, at)));
}, Ve), Gt, Tn = () => (Gt || (Gt = new Sn()), Gt), Rn = Dn(Tn);
const Bn = [1, 1.5, 2, 3, 4], On = 3, ye = 500, An = "png", P = { small: 320, medium: 358, large: 400, tablet: 756 }, Ke = {
  "dim-icons": {
    500: P.small
  },
  "product-badges": {
    500: P.small
  },
  narrow: {
    400: P.small,
    500: P.medium,
    600: P.tablet
  },
  wide: {
    400: P.small,
    500: P.medium,
    600: P.large
  },
  huge: {
    400: P.small,
    500: P.medium,
    600: P.large
  },
  services: {
    500: P.small
  }
}, In = Object.keys(Ke);
function Pn(s, t) {
  const e = Ke[s];
  return e ? (t = Math.max(t, P.small), Object.entries(e).sort((n, o) => n.value - o.value).reduce((n, o) => {
    const [a, r] = o;
    return t >= r ? a : n;
  }, ye)) : ye;
}
function Je(s, t, e, n) {
  const o = Pn(s, e);
  return `https://static.cdn-kaspi.kz/ds/core-illustrations/${t}-${s}-${o}-x${n}.${An}`;
}
function En(s, t, e) {
  return Bn.map((n) => `${Je(s, t, e, n)} ${n}x`).join(", ");
}
const Ln = {
  name: "DsIllustration",
  props: {
    name: {
      type: String,
      required: !0
    },
    type: {
      type: String,
      required: !0,
      validator: (s) => In.includes(s)
    },
    center: Boolean
  },
  setup(s) {
    const { width: t } = Rn(), e = x(() => Je(s.type, s.name, t.value, On)), n = x(() => En(s.type, s.name, t.value)), o = x(() => `illustration-box-${s.type}`);
    return {
      src: e,
      srcset: n,
      sizeClass: o
    };
  }
};
var Fn = function() {
  var t = this, e = t._self._c;
  return e("img", { class: [t.sizeClass, { "illustration--center": t.center }], attrs: { src: t.src, srcset: t.srcset, alt: "" } });
}, Mn = [], zn = /* @__PURE__ */ d(
  Ln,
  Fn,
  Mn,
  !1,
  null,
  "de84838c",
  null,
  null
);
const de = zn.exports;
const Hn = {
  components: {
    DsIllustration: de
  },
  props: {
    badge: {
      type: String,
      required: !0
    }
  }
};
var Nn = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "ds-avatar-badge" }, [e("DsIllustration", { attrs: { name: t.badge, type: "product-badges" } })], 1);
}, Vn = [], Wn = /* @__PURE__ */ d(
  Hn,
  Nn,
  Vn,
  !1,
  null,
  null,
  null,
  null
);
const nd = Wn.exports, Nt = (s) => `var(--${s})`, xe = {
  "light-gray": {
    color: "icon-main",
    background: "icon-back",
    border: null
  },
  "cell-red": {
    color: "icon-brand",
    background: "icon-back",
    border: null
  },
  "cell-black": {
    color: "icon-accent",
    background: "icon-back",
    border: null
  },
  red: {
    color: "icon-inverse",
    background: "brand-kaspi",
    border: null
  },
  green: {
    color: "icon-inverse",
    background: "brand-bonus",
    border: null
  },
  "light-green": {
    color: "icon-inverse",
    background: "brand-credit",
    border: null
  },
  blue: {
    color: "icon-inverse",
    background: "brand-shop",
    border: null
  },
  black: {
    color: "icon-inverse-alt",
    background: "error-back",
    border: null
  },
  success: {
    color: "icon-inverse",
    background: "success-back-alt",
    border: null
  },
  yellow: {
    color: "icon-inverse",
    background: "brand-deposit",
    border: null
  },
  "chart-purple": {
    color: "icon-inverse",
    background: "graph-purple",
    border: null
  },
  "chart-green": {
    color: "icon-inverse",
    background: "graph-green",
    border: null
  },
  "chart-yellow": {
    color: "icon-inverse",
    background: "graph-yellow",
    border: null
  },
  "chart-pink": {
    color: "icon-inverse",
    background: "graph-pink",
    border: null
  },
  "chart-blue": {
    color: "icon-inverse",
    background: "graph-blue",
    border: null
  }
};
const jn = {
  components: {
    DsIcon: R,
    DsIllustration: de
  },
  props: {
    type: {
      type: String,
      default: "light-gray",
      validator(s) {
        return Object.keys(xe).includes(s);
      }
    },
    icon: {
      type: String,
      required: !0
    }
  },
  setup(s) {
    return {
      avatar: x(() => xe[s.type]),
      getColor: Nt
    };
  }
};
var Un = function() {
  var n, o, a;
  var t = this, e = t._self._c;
  return e("div", { staticClass: "ds-avatar-icon", style: {
    boxShadow: (n = t.avatar) != null && n.border ? `0px 0px 0px ${t.avatar.border.width}px ${t.getColor(t.avatar.border.color)} inset` : "none",
    backgroundColor: t.getColor((o = t.avatar) == null ? void 0 : o.background)
  } }, [e("DsIcon", { attrs: { name: t.icon, color: (a = t.avatar) == null ? void 0 : a.color } })], 1);
}, Yn = [], qn = /* @__PURE__ */ d(
  jn,
  Un,
  Yn,
  !1,
  null,
  null,
  null,
  null
);
const od = qn.exports;
const Ce = {
  small: "24px",
  medium: "40px",
  large: "80px"
}, Zn = {
  props: {
    src: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "small",
      validator(s) {
        return Object.keys(Ce).includes(s);
      }
    }
  },
  setup(s) {
    const t = defineEmits(["error"]), e = h(!1), n = x(() => Ce[s.size]);
    O(
      () => s.src,
      () => {
        e.value = !1;
      }
    );
    function o() {
      e.value = !0, t("error");
    }
    return {
      currentSize: n,
      isImageError: e,
      onImageError: o
    };
  }
};
var Xn = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "ds-avatar-image", style: {
    width: t.currentSize,
    height: t.currentSize
  } }, [t.src && !t.isImageError ? e("img", { attrs: { src: t.src, alt: "" }, on: { error: t.onImageError } }) : e("svg", { attrs: { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 80 80" } }, [e("path", { attrs: { fill: "var(--icon-light)", "fill-rule": "evenodd", d: "M16.548 69.902a9.27 9.27 0 0 1 4.724-6.86l9.129-5.003a2.718 2.718 0 0 0 1.409-2.385v-3.402c-.686-.901-2.648-3.71-3.585-7.44a4.095 4.095 0 0 1-1.532-3.196v-4.112c0-.99.368-1.949 1.023-2.698v-5.468c-.057-.566-.282-3.932 2.141-6.71C31.96 20.222 35.37 19 39.997 19c4.626 0 8.036 1.221 10.138 3.63 2.423 2.777 2.198 6.142 2.141 6.708v5.468a4.11 4.11 0 0 1 1.023 2.698v4.112a4.08 4.08 0 0 1-2.381 3.719 23.572 23.572 0 0 1-3.023 5.961c-.255.362-.501.69-.736.978v3.476c0 1.036.573 1.967 1.495 2.43l9.776 4.91a9.214 9.214 0 0 1 4.99 6.837C72.296 62.971 78 52.152 78 40 78 19.013 60.987 2 40 2S2 19.013 2 40c0 12.137 5.69 22.945 14.548 29.902Zm-.088 2.441C6.483 65.07 0 53.292 0 40 0 17.909 17.909 0 40 0s40 17.909 40 40c0 13.295-6.487 25.076-16.468 32.349v2.164c0 4.879-15.395 6.168-23.536 6.168-8.14 0-23.536-1.289-23.536-6.168v-2.17Z", "clip-rule": "evenodd" } })])]);
}, Gn = [], Kn = /* @__PURE__ */ d(
  Zn,
  Xn,
  Gn,
  !1,
  null,
  null,
  null,
  null
);
const rd = Kn.exports, $e = {
  red: {
    color: "text-inverse",
    background: "brand-kaspi",
    border: null
  },
  green: {
    color: "text-inverse",
    background: "brand-bonus",
    border: null
  },
  "light-green": {
    color: "text-inverse",
    background: "brand-credit",
    border: null
  },
  blue: {
    color: "text-inverse",
    background: "brand-shop",
    border: null
  },
  black: {
    color: "text-inverse-alt",
    background: "error-back",
    border: null
  },
  gray: {
    color: "text-main",
    background: "element-fill-light",
    border: {
      width: 1,
      color: "element-border-dark"
    }
  }
};
const Jn = {
  props: {
    letter: {
      type: String,
      required: !0,
      validator(s) {
        return s.length < 3;
      }
    },
    type: {
      type: String,
      default: "red",
      validator(s) {
        return Object.keys($e).includes(s);
      }
    }
  },
  setup(s) {
    return {
      avatar: x(() => $e[s.type]),
      getColor: Nt
    };
  }
};
var Qn = function() {
  var n, o, a, r, i;
  var t = this, e = t._self._c;
  return e("div", { staticClass: "ds-avatar-letter", style: {
    boxShadow: (n = t.avatar) != null && n.border ? `0px 0px 0px ${(o = t.avatar) == null ? void 0 : o.border.width}px ${t.getColor((a = t.avatar) == null ? void 0 : a.border.color)} inset` : "none",
    color: t.getColor((r = t.avatar) == null ? void 0 : r.color),
    backgroundColor: t.getColor((i = t.avatar) == null ? void 0 : i.background)
  }, attrs: { "data-letter": t.letter } });
}, to = [], eo = /* @__PURE__ */ d(
  Jn,
  Qn,
  to,
  !1,
  null,
  null,
  null,
  null
);
const ad = eo.exports, so = {
  childList: !0
};
function no(s, t, e) {
  const n = {
    ...so,
    ...e || {}
  };
  function o() {
    const r = s.map((i) => (i == null ? void 0 : i.offsetWidth) ?? 0).reduce((i, l) => Math.max(i, l), 0);
    t == null || t(r);
  }
  const a = new MutationObserver(o);
  return s.forEach((r) => {
    r instanceof HTMLElement && a.observe(r, n);
  }), {
    disconnect: () => {
      a.disconnect();
    },
    update: o
  };
}
const oo = {
  components: { DsContainer: S, DsIcon: R },
  data() {
    return {
      slotWidth: 0,
      destroySlotObserver: null,
      updateSlots: null
    };
  },
  mounted() {
    const s = [this.$refs.left, this.$refs.right], { disconnect: t, update: e } = no(s, (n) => {
      this.slotWidth = n;
    });
    this.destroySlotObserver = t, this.updateSlots = e;
  },
  updated() {
    var s;
    (s = this.updateSlots) == null || s.call(this);
  },
  beforeDestroy() {
    var s;
    (s = this.destroySlotObserver) == null || s.call(this);
  }
};
var ro = function() {
  var t = this, e = t._self._c;
  return e("DsContainer", { staticClass: "ds-backdrop-header", class: {
    "ds-backdrop-header--tertiary": !t.$slots.default
  } }, [e("div", { staticClass: "ds-backdrop-header__wrapper" }, [e("div", { ref: "left", staticClass: "ds-backdrop-header__left" }, [t.$slots.left ? t._t("left") : e("div", { staticClass: "title-600-heavy" }, [t._t("default")], 2)], 2), t.$slots.left ? e("div", { staticClass: "ds-backdrop-header__center title-500-heavy", style: { left: `${t.slotWidth}px`, right: `${t.slotWidth}px` } }, [t._t("default")], 2) : t._e(), e("div", { ref: "right", staticClass: "ds-backdrop-header__right" }, [t._t("right", function() {
    return [e("button", { staticClass: "ds-backdrop-header__close", on: { click: function(n) {
      return n.preventDefault(), t.$emit("close", n);
    } } }, [e("DsIcon", { attrs: { name: "system/close-500", color: "icon-accent" } })], 1)];
  })], 2)])]);
}, ao = [], io = /* @__PURE__ */ d(
  oo,
  ro,
  ao,
  !1,
  null,
  "1da88799",
  null,
  null
);
const lo = io.exports;
const co = {
  components: { DsBackdropHeader: lo, DsOverlay: ue },
  props: {
    value: Boolean,
    title: {
      type: String,
      default: ""
    },
    fullScreen: Boolean
  },
  emits: ["input"],
  setup() {
    const { setOverflowHidden: s, unsetOverflowHidden: t } = Ze();
    return { setOverflowHidden: s, unsetOverflowHidden: t };
  },
  data() {
    return {
      isOverlayVisible: this.value,
      isBackdropVisible: this.value,
      onTouch: !1,
      touchBlocked: !1,
      startTouchPositionY: 0,
      currentTouchPositionY: 0,
      prevTouchPositionY: 0
    };
  },
  computed: {
    touchOffsetY() {
      return Math.round(Math.max(0, this.currentTouchPositionY - this.startTouchPositionY));
    }
  },
  watch: {
    value(s) {
      if (s) {
        this.setOverflowHidden(), this.isOverlayVisible = !0, setTimeout(() => {
          this.isBackdropVisible = !0;
        }, 200);
        return;
      }
      this.isBackdropVisible = !1, setTimeout(() => {
        this.unsetOverflowHidden(), this.isOverlayVisible = !1;
      }, 200);
    }
  },
  beforeDestroy() {
    this.unsetOverflowHidden();
  },
  methods: {
    onTouchStart(s) {
      this.startTouchPositionY = s.touches[0].clientY, this.currentTouchPositionY = s.touches[0].clientY, this.prevTouchPositionY = null;
    },
    onTouchMove(s) {
      this.$nextTick(() => {
        this.touchBlocked || (this.onTouch = !0, this.prevTouchPositionY = this.currentTouchPositionY, this.currentTouchPositionY = s.touches[0].clientY);
      });
    },
    onTouchEnd() {
      this.onTouch = !1, this.touchBlocked = !1, this.prevTouchPositionY && this.prevTouchPositionY < this.currentTouchPositionY && this.close();
    },
    onContentTouchMove(s) {
      (!this.onTouch && s.touches[0].clientY < this.currentTouchPositionY || this.$refs.backdrop.scrollTop !== 0) && (this.touchBlocked = !0);
    },
    close() {
      this.$emit("input", !1);
    }
  }
};
var uo = function() {
  var t = this, e = t._self._c;
  return e("DsOverlay", { attrs: { visible: t.isOverlayVisible, opacity: "40" }, on: { "click:overlay": t.close } }, [e("div", { ref: "backdrop", staticClass: "ds-backdrop", class: { "ds-backdrop--on-touch": t.onTouch, "ds-backdrop--full-screen": t.fullScreen }, style: { transform: `translateY(${t.onTouch ? `${t.touchOffsetY}px` : t.isBackdropVisible ? 0 : "100%"})` }, on: { touchstart: t.onTouchStart, touchend: t.onTouchEnd, touchmove: t.onTouchMove } }, [e("div", { staticClass: "ds-backdrop__header" }, [e("div", { staticClass: "ds-backdrop__handle" }), e("DsBackdropHeader", { on: { close: t.close }, scopedSlots: t._u([t.$slots.left ? { key: "left", fn: function() {
    return [t._t("left")];
  }, proxy: !0 } : null, t.$slots.right ? { key: "right", fn: function() {
    return [t._t("right")];
  }, proxy: !0 } : null], null, !0) }, [t.title || t.$slots.title ? t._t("title", function() {
    return [t._v(t._s(t.title))];
  }) : t._e()], 2)], 1), t.isOverlayVisible ? e("div", { staticClass: "ds-backdrop__content", on: { touchmove: t.onContentTouchMove } }, [t._t("default")], 2) : t._e()])]);
}, _o = [], fo = /* @__PURE__ */ d(
  co,
  uo,
  _o,
  !1,
  null,
  "8be3e97b",
  null,
  null
);
const po = fo.exports;
const q = Object.freeze({
  BRAND: "brand",
  BONUS: "bonus",
  INSTALLMENT: "installment",
  PRICE: "price",
  GOLD: "gold"
}), gt = Object.freeze({
  L: "l",
  M: "m",
  S: "s"
}), Kt = Object.freeze({
  PILL: "pill",
  RECTANGLE: "rectangle"
}), vo = {
  name: "DsBadge",
  props: {
    type: {
      type: String,
      default: q.BRAND,
      validator: (s) => Object.values(q).includes(s)
    },
    size: {
      type: String,
      default: gt.L,
      validator: (s) => Object.values(gt).includes(s)
    },
    appearance: {
      type: String,
      default: Kt.PILL,
      validator: (s) => Object.values(Kt).includes(s)
    }
  },
  computed: {
    classList() {
      return [
        `badge--type-${this.type}`,
        `badge--size-${this.size}`,
        `badge--appearance-${this.appearance}`,
        this.fontClass
      ];
    },
    fontClass() {
      switch (this.size) {
        case gt.L:
          return [q.PRICE, q.GOLD].includes(this.type) ? "label-500-accent" : "label-500-soft";
        case gt.M:
          return [q.PRICE, q.GOLD].includes(this.type) ? "label-500-accent" : "label-400-soft";
        case gt.S:
          return this.type === q.BRAND && this.appearance === Kt.PILL ? "label-200" : [q.PRICE, q.GOLD].includes(this.type) ? "label-400-accent" : "label-400-soft";
      }
    }
  }
};
var mo = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "badge", class: t.classList }, [t._t("default")], 2);
}, ho = [], go = /* @__PURE__ */ d(
  vo,
  mo,
  ho,
  !1,
  null,
  "6c6cdde8",
  null,
  null
);
const id = go.exports, bo = /* @__PURE__ */ k({
  __name: "DsSpinner",
  props: {
    size: { default: "xs" },
    color: { default: "brand-kaspi" },
    isSpinning: { type: Boolean, default: !0 }
  },
  setup(s) {
    const t = s, e = {
      xs: 16,
      s: 24,
      m: 32,
      l: 44
    }, n = x(() => e[t.size]), o = x(() => ({
      width: n.value,
      height: n.value,
      fill: Nt(t.color),
      maskRepeat: "no-repeat"
    }));
    return { __sfc: !0, props: t, SIZE_MAP: e, pxBySize: n, styles: o };
  }
});
var yo = function() {
  var t = this, e = t._self._c, n = t._self._setupProxy;
  return e("svg", { class: { spinning: t.isSpinning }, style: n.styles, attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: `0 0 ${n.pxBySize} ${n.pxBySize}`, width: n.pxBySize, height: n.pxBySize } }, [t.size === "xs" ? e("path", { attrs: { d: "M8 16C7.44772 16 7 15.5523 7 15C7 14.4477 7.44772 14 8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 8.64723 2.10214 9.27934 2.3002 9.88016C2.4731 10.4047 2.18807 10.9701 1.66355 11.143C1.13902 11.3159 0.573648 11.0308 0.400742 10.5063C0.136285 9.70407 0 8.86063 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16Z" } }) : t._e(), t.size === "s" ? e("path", { attrs: { d: "M12 24C11.3096 24 10.75 23.4404 10.75 22.75C10.75 22.0596 11.3096 21.5 12 21.5C17.2467 21.5 21.5 17.2467 21.5 12C21.5 6.75329 17.2467 2.5 12 2.5C6.75329 2.5 2.5 6.75329 2.5 12C2.5 13.1009 2.68681 14.1746 3.0479 15.1883C3.27953 15.8387 2.94012 16.5537 2.28978 16.7853C1.63945 17.0169 0.924466 16.6775 0.692827 16.0272C0.236162 14.7451 0 13.3878 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24Z" } }) : t._e(), t.size === "m" ? e("path", { attrs: { d: "M16 32C15.0795 32 14.3333 31.2538 14.3333 30.3333C14.3333 29.4129 15.0795 28.6667 16 28.6667C22.9956 28.6667 28.6667 22.9956 28.6667 16C28.6667 9.00439 22.9956 3.33333 16 3.33333C9.00439 3.33333 3.33333 9.00439 3.33333 16C3.33333 17.4679 3.58241 18.8994 4.06386 20.2511C4.37271 21.1182 3.92015 22.0715 3.05304 22.3804C2.18593 22.6892 1.23262 22.2367 0.923769 21.3696C0.314883 19.6601 0 17.8504 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32Z" } }) : t._e(), t.size === "l" ? e("path", { attrs: { d: "M22 44C20.7343 44 19.7083 42.974 19.7083 41.7083C19.7083 40.4427 20.7343 39.4167 22 39.4167C31.619 39.4167 39.4167 31.619 39.4167 22C39.4167 12.381 31.619 4.58333 22 4.58333C12.381 4.58333 4.58333 12.381 4.58333 22C4.58333 24.0184 4.92581 25.9867 5.58781 27.8453C6.01248 29.0376 5.39021 30.3484 4.19793 30.773C3.00565 31.1977 1.69485 30.5754 1.27018 29.3832C0.432964 27.0326 0 24.5443 0 22C0 9.84974 9.84974 0 22 0C34.1503 0 44 9.84974 44 22C44 34.1503 34.1503 44 22 44Z" } }) : t._e()]);
}, xo = [], Co = /* @__PURE__ */ d(
  bo,
  yo,
  xo,
  !1,
  null,
  "1444b2dd",
  null,
  null
);
const Vt = Co.exports, $o = /* @__PURE__ */ k({
  __name: "DsButton",
  props: {
    size: { default: "medium" },
    type: { default: "primary" },
    icon: { default: "" },
    loading: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(s, { emit: t }) {
    const e = s, n = {
      large: "s",
      l: "s",
      medium: "xs",
      m: "xs",
      small: "xs",
      s: "xs"
    }, o = {
      primary: "icon-inverse",
      outline: "action-primary",
      ghost: "action-primary",
      "ghost-alt": "action-primary",
      inverse: "icon-inverse",
      destructive: "action-destructive",
      tinted: "action-primary"
    }, a = x(() => {
      const i = {
        large: "label-600-soft",
        l: "label-600-soft",
        medium: "label-500-soft",
        m: "label-500-soft",
        small: "label-500-soft",
        s: "label-500-soft"
      };
      return {
        [`ds-button--${e.size} ${i[e.size]}`]: e.size,
        [`ds-button--${e.type}`]: e.type
      };
    });
    function r(i) {
      t("click", i);
    }
    return { __sfc: !0, spinnerSizes: n, spinnerColors: o, props: e, emit: t, computedClassNames: a, onClick: r, DsIcon: R, DsSpinner: Vt };
  }
});
var wo = function() {
  var t = this, e = t._self._c, n = t._self._setupProxy;
  return e("button", t._b({ staticClass: "ds-button", class: n.computedClassNames, attrs: { disabled: t.loading }, on: { click: n.onClick } }, "button", t.$attrs, !1), [e("div", { staticClass: "ds-button__spinner", style: { opacity: t.loading ? 1 : 0 } }, [e(n.DsSpinner, { directives: [{ name: "show", rawName: "v-show", value: t.loading, expression: "loading" }], attrs: { size: n.spinnerSizes[t.size], color: n.spinnerColors[t.type] } })], 1), e("div", { staticClass: "ds-button__content", style: { opacity: t.loading ? 0 : 1 } }, [e("div", { staticClass: "ds-button__text" }, [e("div", { staticClass: "ds-button__icon_wrapper" }, [t.icon ? e(n.DsIcon, { staticClass: "ds-button__icon", attrs: { name: t.icon } }) : t._e()], 1), e("div", { staticClass: "line-clamp" }, [t._t("default")], 2)])])]);
}, ko = [], Do = /* @__PURE__ */ d(
  $o,
  wo,
  ko,
  !1,
  null,
  "b8c3ea25",
  null,
  null
);
const So = Do.exports, ld = ["primary", "outline", "ghost", "ghost-alt", "inverse", "destructive", "tinted"], cd = ["small", "medium", "large", "l", "m", "s"];
const To = {
  components: { DsContainer: S },
  props: {
    sticky: Boolean,
    fixed: Boolean,
    divider: Boolean,
    transparent: Boolean,
    layout: {
      type: String,
      default: "vertical",
      validator: (s) => ["vertical", "horizontal"].includes(s)
    }
  }
};
var Ro = function() {
  var t = this, e = t._self._c;
  return e("DsContainer", { staticClass: "ds-button-bar", class: [
    `ds-button-bar--layout-${t.layout}`,
    {
      "ds-button-bar--sticky": t.sticky,
      "ds-button-bar--fixed": t.fixed,
      "ds-button-bar--divider": t.divider,
      "ds-button-bar--transparent": t.transparent
    }
  ] }, [e("div", { staticClass: "ds-button-bar__buttons" }, [t._t("default")], 2), t.$slots.description ? e("div", { staticClass: "ds-button-bar__description caption-500" }, [t._t("description")], 2) : t._e()]);
}, Bo = [], Oo = /* @__PURE__ */ d(
  To,
  Ro,
  Bo,
  !1,
  null,
  null,
  null,
  null
);
const Ao = Oo.exports, Io = /* @__PURE__ */ k({
  __name: "DsCard",
  props: {
    type: { default: "primary" },
    bordered: { type: Boolean, default: !1 }
  },
  setup(s) {
    return { __sfc: !0 };
  }
});
var Po = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { class: [
    `ds-card ds-card--${t.type}`,
    {
      "ds-card--bordered": t.bordered
    }
  ] }, [t._t("default")], 2);
}, Eo = [], Lo = /* @__PURE__ */ d(
  Io,
  Po,
  Eo,
  !1,
  null,
  "cc09b6a0",
  null,
  null
);
const ud = Lo.exports;
const Fo = Object.freeze([!0, !1, "adjacent"]), Mo = {
  name: "DsCell",
  components: {
    DsContainer: S,
    DsIcon: R
  },
  props: {
    ...Ht,
    divider: {
      type: [Boolean, String],
      default: !1,
      validator(s) {
        return Fo.includes(s);
      }
    },
    textHeavy: Boolean,
    chevron: Boolean,
    compact: Boolean,
    multiline: Boolean
  },
  setup() {
    const s = h(null), t = h(!1);
    return j(() => {
      var n;
      const e = ((n = s.value) == null ? void 0 : n.getBoundingClientRect().width) || window.innerWidth;
      setTimeout(() => {
        t.value = e < window.innerWidth * 0.4;
      });
    }), {
      bodyRef: s,
      isVertical: t
    };
  }
};
var zo = function() {
  var t = this, e = t._self._c;
  return e("DsContainer", { staticClass: "ds-cell body-500", class: {
    "ds-cell--chevron": t.chevron,
    "ds-cell--compact": t.compact,
    "ds-cell--multiline": t.multiline,
    "ds-cell--divider": t.divider,
    "body-500-heavy": t.textHeavy,
    "ds-cell--divider-adjacent": t.divider === "adjacent"
  }, attrs: { tag: t.tag } }, [e("div", { staticClass: "ds-cell__wrapper" }, [t.$slots.left ? e("div", { staticClass: "ds-cell__left" }, [t._t("left")], 2) : t._e(), e("div", { staticClass: "ds-cell__center", class: {
    "ds-cell__center--vertical": t.isVertical
  } }, [e("div", { ref: "bodyRef", staticClass: "ds-cell__body" }, [t.$slots.subhead ? e("div", { staticClass: "ds-cell__body_subhead caption-500 text-secondary mb-350", class: {
    "line-clamp-1": !t.multiline
  } }, [t._t("subhead")], 2) : t._e(), e("div", { staticClass: "ds-cell__body_main", class: [t.$slots.subhead || t.$slots.caption ? "line-clamp-1" : "line-clamp-2"] }, [t._t("default")], 2), t.$slots.caption ? e("div", { staticClass: "ds-cell__body_caption caption-500 text-secondary mt-350", class: {
    "line-clamp-1": !t.multiline
  } }, [t._t("caption")], 2) : t._e()]), t.$slots.right ? e("div", { staticClass: "ds-cell__right" }, [t._t("right")], 2) : t._e()]), t.chevron ? e("div", { staticClass: "ds-cell__chevron" }, [e("DsIcon", { attrs: { name: "system/chevron-right-400", color: "icon-light" } })], 1) : t._e()])]);
}, Ho = [], No = /* @__PURE__ */ d(
  Mo,
  zo,
  Ho,
  !1,
  null,
  null,
  null,
  null
);
const Qe = No.exports;
const ts = {
  color: {
    type: String,
    required: !0
  },
  value: {
    type: Number,
    default: 0
  }
}, Vo = {
  name: "DsProgressBar",
  props: {
    ...ts
  },
  computed: {
    background() {
      return Nt(this.color);
    }
  }
};
var Wo = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "ds-progress-bar" }, [e("div", { staticClass: "ds-progress-bar__indicator", style: { width: t.value + "%", background: t.background } })]);
}, jo = [], Uo = /* @__PURE__ */ d(
  Vo,
  Wo,
  jo,
  !1,
  null,
  "bb550cb9",
  null,
  null
);
const Yo = Uo.exports;
const qo = {
  name: "DsCellProgress",
  components: { DsProgressBar: Yo, DsContainer: S },
  props: {
    ...ts,
    ...Ht,
    divider: Boolean
  }
};
var Zo = function() {
  var t = this, e = t._self._c;
  return e("DsContainer", { staticClass: "ds-cell-progress", class: { "ds-cell-progress--divider": t.divider }, attrs: { tag: t.tag } }, [e("div", { staticClass: "ds-cell-progress__wrapper" }, [t.$slots.avatar ? e("div", { staticClass: "ds-cell-progress__avatar" }, [t._t("avatar")], 2) : t._e(), e("div", { staticClass: "ds-cell-progress__main" }, [t.$slots.leftText || t.$slots.leftCaption || t.$slots.rightText || t.$slots.rightCaption ? e("div", { staticClass: "ds-cell-progress__up" }, [e("div", { staticClass: "ds-cell-progress__up-text body-500" }, [e("div", { staticClass: "ds-cell-progress__up-text-left" }, [t._t("leftText")], 2), e("div", { staticClass: "ds-cell-progress__up-text-right" }, [t._t("rightText")], 2)]), e("div", { staticClass: "ds-cell-progress__up-caption caption-500" }, [e("div", { staticClass: "ds-cell-progress__up-caption-left" }, [t._t("leftCaption")], 2), e("div", { staticClass: "ds-cell-progress__up-caption-right" }, [t._t("rightCaption")], 2)])]) : t._e(), e("div", { staticClass: "ds-cell-progress__bar" }, [t._t("bar", function() {
    return [e("DsProgressBar", { attrs: { color: t.color, value: t.value } })];
  })], 2), t.$slots.downText || t.$slots.downCaption ? e("div", { staticClass: "ds-cell-progress__down" }, [e("div", { staticClass: "ds-cell-progress__down-text caption-500" }, [t._t("downText")], 2), e("div", { staticClass: "ds-cell-progress__down-caption caption-500" }, [t._t("downCaption")], 2)]) : t._e()])])]);
}, Xo = [], Go = /* @__PURE__ */ d(
  qo,
  Zo,
  Xo,
  !1,
  null,
  "4baea4bf",
  null,
  null
);
const dd = Go.exports;
const Ko = {
  name: "DsChart",
  props: {
    values: {
      type: Array,
      required: !0,
      validator: (s) => s.every((t) => "color" in t && "weight" in t)
    }
  }
};
var Jo = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "ds-chart" }, t._l(t.values, function(n) {
    return e("div", { staticClass: "ds-chart__value", class: `ds-chart__value_color_${n.color}`, style: { flexGrow: n.weight } });
  }), 0);
}, Qo = [], tr = /* @__PURE__ */ d(
  Ko,
  Jo,
  Qo,
  !1,
  null,
  "273e55f8",
  null,
  null
);
const _d = tr.exports;
const er = k({
  components: {
    DsIcon: R
  },
  props: {
    value: {
      type: Boolean,
      required: !0
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    checked: {
      get() {
        return this.value;
      },
      set(s) {
        this.$emit("input", s);
      }
    }
  },
  methods: {
    handleChange(s) {
      this.disabled || (this.checked = s.target.checked);
    }
  }
});
var sr = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("label", { staticClass: "ds-checkbox", class: { "ds-checkbox--disabled": t.disabled } }, [e("input", { attrs: { type: "checkbox", disabled: t.disabled }, domProps: { checked: t.checked }, on: { change: t.handleChange } }), e("div", { staticClass: "label ds-checkbox__content" }, [t.value ? e("DsIcon", { staticClass: "ds-checkbox__icon", attrs: { name: "system/check-400", color: "icon-inverse" } }) : t._e()], 1)]);
}, nr = [], or = /* @__PURE__ */ d(
  er,
  sr,
  nr,
  !1,
  null,
  null,
  null,
  null
);
const fd = or.exports, Wt = Symbol("chips-group"), rr = ["small", "medium", "large"];
const ar = {
  name: "DsChip",
  props: {
    size: {
      type: String,
      default: "small",
      validator: (s) => rr.includes(s)
    },
    active: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  setup(s) {
    const t = F(Wt, null);
    if (!t)
      return {
        isActive: x(() => s.active),
        onClick: () => null
      };
    const { count: e, active: n, incrementCount: o, setActiveChip: a } = t, r = e.value;
    return o(), {
      isActive: x(() => r === n.value || s.active),
      onClick: () => a(r)
    };
  }
};
var ir = function() {
  var t = this, e = t._self._c;
  return e("button", { class: [`ds-chip ds-chip--${t.size}`, { "ds-chip--active": t.isActive }], attrs: { disabled: t.disabled }, on: { click: t.onClick } }, [t.size !== "small" ? e("span", { staticClass: "ds-chip__caption", class: t.size === "large" ? "caption-600" : "caption-500" }, [t._t("caption")], 2) : t._e(), e("span", { staticClass: "ds-chip__label", class: t.size === "large" ? "label-700-heavy" : "label-500" }, [t._t("default")], 2)]);
}, lr = [], cr = /* @__PURE__ */ d(
  ar,
  ir,
  lr,
  !1,
  null,
  "a56de179",
  null,
  null
);
const pd = cr.exports, we = {
  white: {
    color: "#FFFFFF",
    border: {
      width: 1,
      color: "#C2C2C2"
    }
  },
  black: {
    color: "#000000",
    border: null
  },
  red: {
    color: "#FF0000",
    border: null
  },
  pink: {
    color: "#FFC0CB",
    border: null
  },
  beige: {
    color: "#FAEBD7",
    border: null
  },
  turquoise: {
    color: "#30D5C8",
    border: null
  },
  blue: {
    color: "#0075FF",
    border: null
  },
  green: {
    color: "#04EA04",
    border: null
  }
};
const ur = {
  name: "DsChipFilterColorItem",
  props: {
    type: {
      type: String,
      required: !0,
      validator: (s) => Object.keys(we).includes(s)
    }
  },
  setup(s) {
    return {
      colorItem: x(() => we[s.type])
    };
  }
};
var dr = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "ds-chip-filter-color-item", style: {
    backgroundColor: t.colorItem.color,
    boxShadow: t.colorItem.border ? `0px 0px 0px ${t.colorItem.border.width}px ${t.colorItem.border.color} inset` : "none"
  } });
}, _r = [], fr = /* @__PURE__ */ d(
  ur,
  dr,
  _r,
  !1,
  null,
  "3e487462",
  null,
  null
);
const pr = fr.exports;
const vr = {
  name: "DsChipFilter",
  components: { DsChipFilterColorItem: pr, DsIcon: R },
  props: {
    active: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    color: {
      type: String,
      default: ""
    },
    icon: {
      type: Boolean,
      default: !1
    }
  },
  setup(s) {
    const t = F(Wt, null);
    if (!t)
      return {
        isActive: x(() => s.active),
        onClick: () => null
      };
    const { count: e, active: n, incrementCount: o, setActiveChip: a } = t, r = e.value;
    return o(), {
      isActive: x(() => r === n.value || s.active),
      onClick: () => a(r)
    };
  }
};
var mr = function() {
  var t = this, e = t._self._c;
  return e("button", { staticClass: "ds-chip-filter label-500", class: { "ds-chip-filter--active": t.isActive }, attrs: { disabled: t.disabled }, on: { click: t.onClick } }, [t._t("colorItem", function() {
    return [t.color ? e("DsChipFilterColorItem", { attrs: { type: t.color } }) : t._e()];
  }), e("span", { staticClass: "ds-chip-filter__label" }, [t._t("default")], 2), t.icon && !t.disabled ? e("DsIcon", { attrs: { name: t.isActive ? "system/hide-400" : "system/chevron-down-400" } }) : t._e()], 2);
}, hr = [], gr = /* @__PURE__ */ d(
  vr,
  mr,
  hr,
  !1,
  null,
  "d556431d",
  null,
  null
);
const vd = gr.exports;
const br = {
  name: "DsChipImage",
  props: {
    src: {
      type: String,
      required: !0
    },
    active: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  setup(s) {
    const t = F(Wt, null);
    if (!t)
      return {
        isActive: x(() => s.active),
        onClick: () => null
      };
    const { count: e, active: n, incrementCount: o, setActiveChip: a } = t, r = e.value;
    return o(), {
      isActive: x(() => r === n.value || s.active),
      onClick: () => a(r)
    };
  }
};
var yr = function() {
  var t = this, e = t._self._c;
  return e("button", { staticClass: "ds-chip-image", class: { "ds-chip-image--active": t.isActive }, attrs: { disabled: t.disabled }, on: { click: t.onClick } }, [t._t("default", function() {
    return [e("img", { attrs: { src: t.src, alt: "" } })];
  })], 2);
}, xr = [], Cr = /* @__PURE__ */ d(
  br,
  yr,
  xr,
  !1,
  null,
  "7b0b896a",
  null,
  null
);
const md = Cr.exports;
const $r = {
  name: "DsChipSuggest",
  props: {
    disabled: {
      type: Boolean,
      default: !1
    }
  }
};
var wr = function() {
  var t = this, e = t._self._c;
  return e("button", { staticClass: "ds-chip-suggest label-500", attrs: { disabled: t.disabled } }, [t._t("default")], 2);
}, kr = [], Dr = /* @__PURE__ */ d(
  $r,
  wr,
  kr,
  !1,
  null,
  "7d6d0d46",
  null,
  null
);
const hd = Dr.exports;
const Sr = {
  components: { DsContainer: S },
  props: {
    scrolling: Boolean,
    image: Boolean,
    value: {
      type: Number,
      required: !0
    },
    minChipWidth: {
      type: Number,
      default: 68
    }
  },
  setup(s, { emit: t }) {
    const e = h(0), n = x({
      get() {
        return s.value;
      },
      set(r) {
        t("input", r);
      }
    });
    function o(r) {
      n.value = r;
    }
    function a() {
      e.value += 1;
    }
    ot(Wt, { active: n, count: e, setActiveChip: o, incrementCount: a });
  }
};
var Tr = function() {
  var t = this, e = t._self._c;
  return e("DsContainer", { staticClass: "ds-chips-group", class: {
    "ds-chips-group--image": t.image,
    "ds-chips-group--scrolling": t.scrolling
  }, style: {
    "grid-template-columns": `repeat(auto-fit, minmax(${t.minChipWidth / 16}rem, 1fr))`
  } }, [t._t("default")], 2);
}, Rr = [], Br = /* @__PURE__ */ d(
  Sr,
  Tr,
  Rr,
  !1,
  null,
  null,
  null,
  null
);
const gd = Br.exports;
const Or = {
  name: "DsDivider",
  props: {
    vertical: {
      type: Boolean,
      default: !1
    }
  }
};
var Ar = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "ds-divider", class: {
    "ds-divider--vertical": t.vertical
  } });
}, Ir = [], Pr = /* @__PURE__ */ d(
  Or,
  Ar,
  Ir,
  !1,
  null,
  null,
  null,
  null
);
const Er = Pr.exports, It = Object.freeze({
  default: "default",
  heavy: "heavy"
});
function Lr(s, t) {
  const e = h(s.expanded), n = x({
    get() {
      return e.value;
    },
    set(i) {
      e.value = i, t("update:expanded", i);
    }
  });
  O(
    () => s.expanded,
    (i) => {
      e.value = i;
    }
  );
  const o = x(() => s.increaseTitleOnExpand && s.expanded ? "title-600-heavy" : s.type === It.heavy ? "title-500-heavy" : "body-500");
  function a() {
  }
  function r() {
    n.value = !n.value;
  }
  return {
    isVisible: n,
    titleClass: o,
    init: a,
    updateExpand: r
  };
}
function Fr(s, t) {
  const e = x(() => n.value === (t == null ? void 0 : t.value.active)), n = h(null), o = x(() => e.value ? "title-600-heavy" : s.type === It.heavy ? "title-500-heavy" : "body-500");
  function a() {
    t.value.count += 1, n.value = t.value.count;
  }
  function r() {
    t.value.active = e.value ? null : n.value;
  }
  return {
    isVisible: e,
    titleClass: o,
    init: a,
    updateExpand: r
  };
}
const Mr = {
  __name: "DsExpand",
  props: {
    expanded: Boolean,
    divider: Boolean,
    increaseTitleOnExpand: Boolean,
    flat: Boolean,
    type: {
      type: String,
      default: It.default,
      validator: (s) => Object.values(It).includes(s)
    }
  },
  emits: ["update:expanded"],
  setup(s, { emit: t }) {
    const e = s, n = F("accordion", null), o = je(n ? Fr(e, n) : Lr(e, t));
    return ae(() => {
      o.init();
    }), { __sfc: !0, emit: t, props: e, accordion: n, ctx: o, DsExpandTransition: Ue, DsContainer: S, DsIcon: R, DsDivider: Er };
  }
};
var zr = function() {
  var t = this, e = t._self._c, n = t._self._setupProxy;
  return e("div", { staticClass: "ds-expand", class: [`ds-expand--${t.type}`, { "ds-expand--expanded": n.ctx.isVisible }] }, [e(n.DsContainer, { staticClass: "ds-expand__head-container" }, [e("button", { staticClass: "ds-expand__head", on: { click: n.ctx.updateExpand } }, [e("span", { staticClass: "ds-expand__title-wrapper" }, [e("span", { staticClass: "ds-expand__title", class: n.ctx.titleClass }, [t._t("title")], 2), t.$slots.caption ? e("span", { staticClass: "ds-expand__caption caption-600" }, [t._t("caption")], 2) : t._e()]), t.$slots.value ? e("span", { staticClass: "ds-expand__value body-500" }, [t._t("value")], 2) : t._e(), t._t("chevron", function() {
    return [e(n.DsIcon, { staticClass: "ds-expand__chevron", attrs: { name: "chevron-down-400", color: "icon-light" } })];
  })], 2)]), e(n.DsExpandTransition, [n.ctx.isVisible ? e("div", { staticClass: "ds-expand__body body-500" }, [e(t.flat ? "div" : n.DsContainer, { tag: "component", staticClass: "pb-550" }, [t._t("default")], 2)], 1) : t._e()]), t.divider ? e(n.DsContainer, [e(n.DsDivider)], 1) : t._e()], 1);
}, Hr = [], Nr = /* @__PURE__ */ d(
  Mr,
  zr,
  Hr,
  !1,
  null,
  "c6f02d65",
  null,
  null
);
const bd = Nr.exports, Vr = {
  name: "DsIconBack",
  components: {
    DsIcon: R
  },
  props: {
    color: {
      type: String,
      default: "icon-accent",
      validator: (s) => /^icon-.+$/.test(s)
    }
  },
  data() {
    return { isAndroid: le };
  }
};
var Wr = function() {
  var t = this, e = t._self._c;
  return t.isAndroid ? e("DsIcon", { attrs: { name: "arrow-left-500", color: t.color } }) : e("DsIcon", { attrs: { name: "system/chevron-left-500", color: t.color } });
}, jr = [], Ur = /* @__PURE__ */ d(
  Vr,
  Wr,
  jr,
  !1,
  null,
  null,
  null,
  null
);
const yd = Ur.exports, Yr = {
  error: {
    "x-small": {
      icon: "alert-400",
      color: "error-icon-light",
      background: "transparent"
    },
    small: {
      icon: "exclamation-mark-400",
      color: "error-icon-dark",
      background: "var(--error-icon-light)"
    },
    medium: {
      icon: "exclamation-mark-500",
      color: "error-icon-dark",
      background: "var(--error-icon-light)"
    },
    large: {
      icon: "exclamation-mark-700",
      color: "error-icon-light",
      background: "var(--error-icon-dark)"
    },
    "x-large": {
      icon: "exclamation-mark-700",
      color: "error-icon-light",
      background: "var(--error-icon-dark)"
    }
  },
  info: {
    "x-small": {
      icon: "info-mark-status-icon-400",
      color: "icon-inverse",
      background: "var(--action-primary)"
    },
    small: {
      icon: "info-mark-400",
      color: "icon-inverse",
      background: "var(--action-primary)"
    },
    medium: {
      icon: "info-mark-400",
      color: "icon-inverse",
      background: "var(--action-primary)"
    },
    large: {
      icon: "info-mark-700",
      color: "neutral-icon",
      background: "var(--neutral-back-alt)"
    },
    "x-large": {
      icon: "info-mark-700",
      color: "neutral-icon",
      background: "var(--neutral-back-alt)"
    }
  },
  // var%28%2D%2Dwarning%2Dicon%29
  warning: {
    "x-small": {
      icon: "",
      color: "",
      background: `url('data:image/svg+xml,<svg width="16" height="16" xmlns="http://www.w3.org/2000/svg"><path d="M6.278 1.973c.776-1.297 2.668-1.297 3.444 0l5.994 10.024c.793 1.325-.17 3.003-1.722 3.003H2.006C.453 15-.51 13.322.284 11.997L6.278 1.973Z" fill="%23F5BA3C"/><path d="M7.2 9.5a.8.8 0 1 0 1.6 0v-4a.8.8 0 1 0-1.6 0v4ZM8 13a.9.9 0 1 0 0-1.8.9.9 0 0 0 0 1.8Z" fill="%23fff"/></svg>')`
    },
    small: {
      icon: "",
      color: "",
      background: `url('data:image/svg+xml,<svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.355 3.531c1.163-2.041 4.127-2.041 5.29 0l7.957 13.971c1.145 2.01-.318 4.498-2.644 4.498H4.042c-2.326 0-3.789-2.488-2.644-4.498l7.957-13.97Z" fill="%23F5BA3C"/><path d="M11 15a1 1 0 1 0 2 0V8a1 1 0 1 0-2 0v7ZM12 17a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z" fill="%23fff"/></svg>')`
    },
    medium: {
      icon: "",
      color: "",
      background: `url('data:image/svg+xml,<svg width="32" height="32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.557 4.925c1.56-2.567 5.327-2.567 6.886 0l10.979 18.07C32.028 25.636 30.099 29 26.978 29H5.022c-3.121 0-5.05-3.363-3.444-6.006L12.557 4.925Z" fill="%23F5BA3C" class="ic"/><path d="M15 20a1 1 0 1 0 2 0v-7a1 1 0 1 0-2 0v7ZM16 22a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z" fill="%23fff"/></svg>')`
    },
    large: {
      icon: "",
      color: "",
      background: `url('data:image/svg+xml,<svg width="60" height="60" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22.83 12.003c3.185-5.337 11.155-5.337 14.34 0L53.88 40c3.184 5.334-.8 12-7.17 12H13.29c-6.37 0-10.354-6.666-7.17-12l16.71-27.997Z" fill="%23F5BA3C"/><path d="M28 34.435a2 2 0 1 0 4 0V19.438a2 2 0 1 0-4 0v14.997ZM30 40a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z" fill="%23fff"/></svg>')`
    },
    "x-large": {
      icon: "",
      color: "",
      background: `url('data:image/svg+xml,<svg width="80" height="80" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M30.197 12.583c4.397-7.444 15.209-7.444 19.606 0l25.61 43.35C79.872 63.483 74.405 73 65.608 73H14.391C5.594 73 .128 63.482 4.588 55.933l25.609-43.35Z" fill="%23F5BA3C"/><path d="M38 44.435a2 2 0 1 0 4 0V29.438a2 2 0 1 0-4 0v14.997ZM40 50a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z" fill="%23fff"/></svg>')`
    }
  },
  success: {
    "x-small": {
      icon: "check-status-icon-400",
      color: "icon-inverse",
      background: "var(--success-icon)"
    },
    small: {
      icon: "check-400",
      color: "icon-inverse",
      background: "var(--success-icon)"
    },
    medium: {
      icon: "check-500",
      color: "icon-inverse",
      background: "var(--success-icon)"
    },
    large: {
      icon: "check-700",
      color: "icon-inverse",
      background: "var(--success-icon)"
    },
    "x-large": {
      icon: "check-700",
      color: "icon-inverse",
      background: "var(--success-icon)"
    }
  }
}, qr = "5.9.0", Zr = 60, Xr = 0, Gr = 120, Kr = 123, Jr = 123, Qr = "Композиция 1", ta = 0, ea = [], sa = [
  {
    ddd: 0,
    ind: 1,
    ty: 4,
    nm: "Checkmark",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [
          60.825,
          555.319,
          0
        ],
        ix: 2,
        l: 2
      },
      a: {
        a: 0,
        k: [
          0,
          0,
          0
        ],
        ix: 1,
        l: 2
      },
      s: {
        a: 0,
        k: [
          180,
          180,
          100
        ],
        ix: 6,
        l: 2
      }
    },
    ao: 0,
    shapes: [
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    -13.938,
                    -273.938
                  ],
                  [
                    -4.938,
                    -264.562
                  ],
                  [
                    14.688,
                    -284.125
                  ]
                ],
                c: !1
              },
              ix: 2
            },
            nm: "Контур 1",
            mn: "ADBE Vector Shape - Group",
            hd: !1
          },
          {
            ty: "st",
            c: {
              a: 0,
              k: [
                1,
                1,
                1,
                1
              ],
              ix: 3
            },
            o: {
              a: 0,
              k: 100,
              ix: 4
            },
            w: {
              a: 0,
              k: 4,
              ix: 5
            },
            lc: 2,
            lj: 1,
            ml: 4,
            bm: 0,
            nm: "Обводка 1",
            mn: "ADBE Vector Graphic - Stroke",
            hd: !1
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "Transform"
          }
        ],
        nm: "Фигура 1",
        np: 3,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: !1
      },
      {
        ty: "tm",
        s: {
          a: 0,
          k: 0,
          ix: 1
        },
        e: {
          a: 1,
          k: [
            {
              i: {
                x: [
                  0.667
                ],
                y: [
                  1
                ]
              },
              o: {
                x: [
                  0.333
                ],
                y: [
                  0
                ]
              },
              t: 36,
              s: [
                0
              ]
            },
            {
              t: 46,
              s: [
                100
              ]
            }
          ],
          ix: 2
        },
        o: {
          a: 0,
          k: 0,
          ix: 3
        },
        m: 1,
        ix: 2,
        nm: "Обрезать контуры 1",
        mn: "ADBE Vector Filter - Trim",
        hd: !1
      }
    ],
    ip: 0,
    op: 120,
    st: 0,
    bm: 0
  },
  {
    ddd: 0,
    ind: 2,
    ty: 4,
    nm: "Circle",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [
          61.463,
          61.5,
          0
        ],
        ix: 2,
        l: 2
      },
      a: {
        a: 0,
        k: [
          0,
          -274.318,
          0
        ],
        ix: 1,
        l: 2
      },
      s: {
        a: 1,
        k: [
          {
            i: {
              x: [
                0.833,
                0.833,
                0.833
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.333,
                0.333,
                0.333
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 16,
            s: [
              0,
              0,
              100
            ]
          },
          {
            i: {
              x: [
                0.833,
                0.833,
                0.833
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.167,
                0.167,
                0.167
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 30,
            s: [
              200,
              200,
              100
            ]
          },
          {
            i: {
              x: [
                0.833,
                0.833,
                0.833
              ],
              y: [
                1,
                1,
                1
              ]
            },
            o: {
              x: [
                0.167,
                0.167,
                0.167
              ],
              y: [
                0,
                0,
                0
              ]
            },
            t: 36,
            s: [
              180,
              180,
              100
            ]
          },
          {
            t: 42,
            s: [
              200,
              200,
              100
            ]
          }
        ],
        ix: 6,
        l: 2
      }
    },
    ao: 0,
    shapes: [
      {
        ty: "gr",
        it: [
          {
            d: 1,
            ty: "el",
            s: {
              a: 0,
              k: [
                22.734,
                60.62
              ],
              ix: 2
            },
            p: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 3
            },
            nm: "Контур эллипса 1",
            mn: "ADBE Vector Shape - Ellipse",
            hd: !1
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.172549024224,
                0.670588254929,
                0,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: "Заливка 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: !1
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                0.019,
                -274.318
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                263.721,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "Transform"
          }
        ],
        nm: "Эллипс 1",
        np: 3,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: !1
      }
    ],
    ip: 0,
    op: 120,
    st: 0,
    bm: 0
  }
], na = [], oa = {
  v: qr,
  fr: Zr,
  ip: Xr,
  op: Gr,
  w: Kr,
  h: Jr,
  nm: Qr,
  ddd: ta,
  assets: ea,
  layers: sa,
  markers: na
}, ra = {
  props: {
    data: {
      type: Object,
      required: !0
    },
    value: {
      type: [Object, null],
      default: null
    },
    loop: Boolean,
    autoplay: Boolean
  },
  emits: ["error"],
  data() {
    return {
      containerRef: null
    };
  },
  async mounted() {
    try {
      (await import("./lottie_light.min-c156d05f.mjs").then((t) => t.l)).loadAnimation({
        container: this.$refs.containerRef,
        renderer: "svg",
        loop: this.loop,
        autoplay: this.autoplay,
        animationData: this.data,
        renderSettings: {
          progressiveLoad: !0
        }
      });
    } catch (s) {
      this.$emit("error", s);
    }
  }
};
var aa = function() {
  var t = this, e = t._self._c;
  return e("div", { ref: "containerRef" });
}, ia = [], la = /* @__PURE__ */ d(
  ra,
  aa,
  ia,
  !1,
  null,
  null,
  null,
  null
);
const ca = la.exports, ua = /* @__PURE__ */ k({
  __name: "DsStatusIcon",
  props: {
    type: { default: "success" },
    size: { default: "small" },
    animated: { type: Boolean, default: !1 }
  },
  setup(s) {
    const t = s, e = x(() => t.type === "success" && t.animated), n = x(() => {
      var o;
      return ((o = Yr[t.type]) == null ? void 0 : o[t.size]) || null;
    });
    return { __sfc: !0, props: t, isSuccessAnimated: e, statusIcon: n, successAnimationData: oa, DsIcon: R, DsLottieAnimation: ca };
  }
});
var da = function() {
  var t = this, e = t._self._c, n = t._self._setupProxy;
  return e("div", { staticClass: "ds-status-icon", class: [
    `ds-status-icon--${t.size}`,
    `ds-status-icon--${t.type}`,
    {
      "ds-status-icon--animated": t.animated
    }
  ], style: {
    background: n.statusIcon.background + "center center no-repeat"
  } }, [n.isSuccessAnimated ? e(n.DsLottieAnimation, { attrs: { data: n.successAnimationData, autoplay: "" } }) : n.statusIcon.icon ? e(n.DsIcon, { attrs: { name: n.statusIcon.icon, color: n.statusIcon.color } }) : t._e()], 1);
}, _a = [], fa = /* @__PURE__ */ d(
  ua,
  da,
  _a,
  !1,
  null,
  "ce1852c6",
  null,
  null
);
const Dt = fa.exports, pa = /* @__PURE__ */ k({
  __name: "DsInformer",
  props: {
    status: { default: "info" },
    size: { default: "l" },
    container: { type: Boolean, default: !1 },
    icon: { type: Boolean, default: !1 }
  },
  setup(s) {
    const t = s, e = {
      s: "x-small",
      l: "small"
    }, n = x(() => {
      if (t.icon) {
        if (t.status === "info" || t.status === "warning")
          return t.status;
        if (t.status === "positive")
          return "success";
        if (t.status === "negative")
          return "error";
      }
    });
    return { __sfc: !0, statusIconSizes: e, props: t, statusIcon: n, DsStatusIcon: Dt, DsContainer: S };
  }
});
var va = function() {
  var t = this, e = t._self._c, n = t._self._setupProxy;
  return e(t.container ? n.DsContainer : "div", { tag: "component", staticClass: "ds-informer", class: [
    `ds-informer--${t.status} ds-informer--${t.size}`,
    {
      "ds-informer--container": t.container
    }
  ] }, [e("div", { staticClass: "ds-informer__wrapper" }, [n.statusIcon ? e("div", { staticClass: "ds-informer__status-icon" }, [e(n.DsStatusIcon, { attrs: { type: n.statusIcon, size: n.statusIconSizes[t.size] } })], 1) : t._e(), e("div", { staticClass: "ds-informer__main" }, [t.$slots.title && t.size !== "s" ? e("div", { staticClass: "ds-informer__title title-400-heavy" }, [t._t("title")], 2) : t._e(), t.$slots.default ? e("div", { staticClass: "ds-informer__description", class: {
    "body-300": t.size === "s",
    "body-400": t.size === "l"
  } }, [t._t("default")], 2) : t._e(), t.$slots.action && t.size !== "s" ? e("div", { staticClass: "ds-informer__action label-400" }, [t._t("action")], 2) : t._e()]), t.$slots.right && t.size !== "s" ? e("div", { staticClass: "ds-informer__right" }, [t._t("right")], 2) : t._e()])]);
}, ma = [], ha = /* @__PURE__ */ d(
  pa,
  va,
  ma,
  !1,
  null,
  null,
  null,
  null
);
const xd = ha.exports, bt = Object.freeze({
  POSITIVE: "positive",
  NEUTRAL: "neutral",
  NEGATIVE: "negative"
});
const ga = {
  [bt.POSITIVE]: "success",
  [bt.NEGATIVE]: "error"
}, ba = {
  name: "DsInlineStatus",
  components: { DsContainer: S, DsStatusIcon: Dt },
  props: {
    status: {
      type: String,
      default: bt.POSITIVE,
      validator: (s) => Object.values(bt).includes(s)
    }
  },
  computed: {
    statusIcon() {
      return ga[this.status];
    },
    isNeutral() {
      return this.status === bt.NEUTRAL;
    }
  }
};
var ya = function() {
  var t = this, e = t._self._c;
  return e("DsContainer", { staticClass: "ds-inline-status", class: `ds-inline-status--${t.status}` }, [e("div", { staticClass: "ds-inline-status__wrapper" }, [!t.isNeutral || t.$slots.icon ? e("div", { staticClass: "ds-inline-status__icon" }, [t._t("icon", function() {
    return [e("DsStatusIcon", { attrs: { type: t.statusIcon } })];
  })], 2) : t._e(), e("div", { staticClass: "ds-inline-status__content" }, [e("div", { staticClass: "ds-inline-status__text body-500" }, [t._t("default")], 2), t.$slots.caption ? e("div", { staticClass: "ds-inline-status__caption caption-500" }, [t._t("caption")], 2) : t._e()]), t.$slots.button ? e("div", { staticClass: "ds-inline-status__button" }, [t._t("button")], 2) : t._e()])]);
}, xa = [], Ca = /* @__PURE__ */ d(
  ba,
  ya,
  xa,
  !1,
  null,
  "12af7797",
  null,
  null
);
const Cd = Ca.exports, Pt = /* @__PURE__ */ new WeakMap(), Et = (s, t, e, n = 0) => {
  Pt.has(s) !== e && (e ? wa(s, t, n) : ka(s, t));
}, $a = (s) => s === s.getRootNode().activeElement, wa = (s, t, e) => {
  const n = t.parentNode, o = t.cloneNode(!1);
  o.classList.add("cloned-input"), o.tabIndex = -1, n.appendChild(o), Pt.set(s, o), s.style.pointerEvents = "none", t.style.transform = `translate3d(-9999px,${e}px,0) scale(0)`;
}, ka = (s, t) => {
  const e = Pt.get(s);
  e && (Pt.delete(s), e.remove()), s.style.pointerEvents = "", t.style.transform = "";
}, es = (s) => s == null || s === document.documentElement ? document : s.scrollHeight > s.clientHeight ? s : es(s.parentNode), Da = (s, t, e) => {
  if (!s || !t || !e)
    return () => {
    };
  const n = (u) => {
    $a(t) && Et(s, t, u);
  }, o = () => Et(s, t, !1), a = () => n(!0), r = () => n(!1);
  let i = null, l = !1;
  const c = () => {
    l || (window.requestAnimationFrame(() => {
      i !== null ? clearTimeout(i) : a(), i = setTimeout(function() {
        r(), i = null;
      }, 150), l = !1;
    }), l = !0);
  };
  return e.addEventListener("scroll", c), t.addEventListener("blur", o), () => {
    e.removeEventListener("scroll", c), t.removeEventListener("blur", o);
  };
}, ee = "data-skip-scroll-assist", Sa = (s, t) => {
  const e = () => {
    if (t.hasAttribute(ee)) {
      t.removeAttribute(ee);
      return;
    }
    Ta(s, t);
  };
  return s.addEventListener("focusin", e, !0), () => {
    s.removeEventListener("focusin", e, !0);
  };
}, ke = (s) => {
  document.activeElement !== s && (s.setAttribute(ee, "true"), s.focus());
}, Ta = (s, t) => {
  var o, a;
  Et(s, t, !0), ke(t), setTimeout(() => {
    s.click();
  });
  let e;
  const n = () => {
    var r, i, l;
    e !== void 0 && clearTimeout(e), window.removeEventListener("keyboardDidShow", n), (i = (r = window.visualViewport) == null ? void 0 : r.removeEventListener) == null || i.call(r, "resize", n), Ra(s, 100) || (l = s.scrollIntoView) == null || l.call(s, { block: "center", behavior: "smooth" }), Et(s, t, !1), ke(t);
  };
  window.addEventListener("keyboardDidShow", n), (a = (o = window.visualViewport) == null ? void 0 : o.addEventListener) == null || a.call(o, "resize", n), e = setTimeout(n, 500);
}, Ra = (s, t = 0) => {
  const e = s.getBoundingClientRect();
  return e.top >= t && e.bottom <= (window.visualViewport.height || window.innerHeight) - t;
}, ss = (s, t) => {
  if (!yt)
    return () => {
    };
  const e = es(s), n = Da(s, t, e), o = Sa(s, t);
  return () => {
    n(), o();
  };
};
const ns = {
  value: {
    type: String,
    default: ""
  },
  hint: {
    type: String,
    default: ""
  },
  error: {
    type: [Boolean, String],
    default: !1
  },
  type: {
    type: String,
    default: "text"
  },
  label: {
    type: String,
    default: ""
  },
  icon: {
    type: String,
    default: ""
  },
  placeholder: {
    type: String,
    default: ""
  },
  required: Boolean,
  disabled: Boolean,
  autofocus: Boolean
}, os = ["input", "focus", "blur", "click:icon"], Ba = {
  components: { DsContainer: S, DsIcon: R },
  props: ns,
  emits: os,
  data() {
    return { focused: !1, stopUseInputHacks: null };
  },
  computed: {
    active() {
      var s;
      return this.focused || ((s = this.value) == null ? void 0 : s.length);
    },
    iconColor() {
      return this.disabled ? "icon-light" : "icon-brand";
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.stopUseInputHacks = ss(this.$refs.label, this.$refs.input), this.autofocus && this.focus();
    });
  },
  beforeDestroy() {
    var s;
    (s = this.stopUseInputHacks) == null || s.call(this);
  },
  methods: {
    focus() {
      var s, t;
      (t = (s = this.$refs.input) == null ? void 0 : s.focus) == null || t.call(s);
    },
    blur() {
      var s, t;
      (t = (s = this.$refs.input) == null ? void 0 : s.blur) == null || t.call(s);
    },
    onFocus(s) {
      this.focused = !0, this.$emit("focus", s);
    },
    onBlur(s) {
      var t, e;
      if (this.clearing) {
        this.clearing = !1, (e = (t = this.$refs.input) == null ? void 0 : t.focus) == null || e.call(t);
        return;
      }
      this.focused = !1, this.$emit("blur", s);
    },
    onClear() {
      this.clearing = !0, this.$emit("input", "");
    }
  }
};
var Oa = function() {
  var n;
  var t = this, e = t._self._c;
  return e("DsContainer", { staticClass: "ds-input", class: {
    "ds-input--disabled": t.disabled,
    "ds-input--active": t.active,
    "ds-input--focused": t.focused,
    "ds-input--error": t.error,
    "ds-input--placeholder": !!t.placeholder
  } }, [e("label", { ref: "label", staticClass: "ds-input__container" }, [e("span", { staticClass: "ds-input__main" }, [t.$slots.prepend ? e("span", { staticClass: "ds-input__prepend" }, [t._t("prepend")], 2) : t._e(), e("span", { staticClass: "ds-input__wrapper" }, [t.label && !t.placeholder ? e("span", { staticClass: "ds-input__label", class: t.active ? "caption-500" : "caption-700" }, [t._v(" " + t._s(t.label) + " ")]) : t._e(), e("input", t._b({ ref: "input", staticClass: "ds-input__input body-500", class: { "body-700": !!t.placeholder && t.active && t.value.length > 0 }, attrs: { disabled: t.disabled, type: t.type, placeholder: t.placeholder }, domProps: { value: t.value }, on: { input: function(o) {
    return t.$emit("input", o.target.value);
  }, focus: t.onFocus, blur: t.onBlur } }, "input", { ...t.$props, ...t.$attrs }, !1))]), e("span", { staticClass: "ds-input__append caption-700" }, [t._t("append", function() {
    return [e("Transition", { attrs: { name: "ds-input__icon" } }, [t.icon ? e("button", { staticClass: "ds-input__icon", attrs: { type: "button", tabindex: "-1" }, on: { mousedown: function(o) {
      return o.preventDefault(), t.$emit("click:icon", o);
    } } }, [e("DsIcon", { attrs: { name: t.icon, color: t.iconColor } })], 1) : t.value && t.focused && !t.disabled ? e("button", { staticClass: "ds-input__clear", attrs: { type: "button", tabindex: "-1" }, on: { mousedown: t.onClear, click: function(o) {
      o.preventDefault();
    } } }, [e("DsIcon", { attrs: { name: "system/clear-400", color: "icon-light" } })], 1) : t._e()])];
  })], 2), e("span", { staticClass: "ds-input__indicator" })])]), (n = t.error) != null && n.length ? e("span", { staticClass: "ds-input__error caption-500" }, [t._v(t._s(t.error))]) : t.hint ? e("span", { staticClass: "ds-input__hint caption-500" }, [t._v(t._s(t.hint))]) : t._e()]);
}, Aa = [], Ia = /* @__PURE__ */ d(
  Ba,
  Oa,
  Aa,
  !1,
  null,
  null,
  null,
  null
);
const Pa = Ia.exports;
const Ea = {
  name: "DsRadioButton",
  props: {
    option: {
      type: [String, Number],
      required: !0
    },
    value: {
      type: [String, Number],
      default: ""
    }
  },
  emits: ["input"],
  computed: {
    isChecked() {
      return this.option === this.value;
    }
  }
};
var La = function() {
  var t = this, e = t._self._c;
  return e("input", { staticClass: "ds-radio-button", attrs: { type: "radio" }, domProps: { value: t.option, checked: t.isChecked }, on: { change: function(n) {
    return t.$emit("input", t.option);
  } } });
}, Fa = [], Ma = /* @__PURE__ */ d(
  Ea,
  La,
  Fa,
  !1,
  null,
  "e24360f5",
  null,
  null
);
const za = Ma.exports;
const Ha = {
  name: "DsDropdown",
  components: {
    DsContainer: S,
    DsRadioButton: za,
    DsBackdrop: po,
    DsCell: Qe,
    DsIcon: R
  },
  props: {
    title: {
      type: String,
      required: !0,
      default: ""
    },
    value: {
      type: [String, Number],
      default: null
    },
    options: {
      type: Array,
      required: !0
    },
    error: {
      type: [Boolean, String],
      default: !1
    },
    disabled: Boolean,
    required: Boolean,
    hint: {
      type: String,
      default: ""
    },
    custom: Boolean,
    active: Boolean
  },
  emits: ["input", "click"],
  data() {
    return { isOpen: !1 };
  },
  computed: {
    label() {
      var s;
      return this.custom ? this.value : (s = this.options.find((t) => t.value === this.value)) == null ? void 0 : s.label;
    }
  },
  methods: {
    open(s) {
      if (!this.disabled) {
        if (this.custom) {
          this.$emit("click", s);
          return;
        }
        this.isOpen = !0;
      }
    },
    clickValueHandler(s) {
      this.isOpen = !1, this.$emit("input", s);
    }
  }
};
var Na = function() {
  var n;
  var t = this, e = t._self._c;
  return e("DsContainer", { staticClass: "ds-dropdown", class: {
    "ds-dropdown--open": t.isOpen || t.active,
    "ds-dropdown--disabled": t.disabled,
    "ds-dropdown--error": t.error,
    "ds-dropdown--active": t.label,
    "ds-dropdown--required": t.required
  } }, [e("button", { staticClass: "ds-dropdown__container", on: { click: function(o) {
    return o.preventDefault(), t.open.apply(null, arguments);
  } } }, [e("span", { staticClass: "ds-dropdown__wrapper" }, [e("span", { staticClass: "ds-dropdown__text" }, [e("span", { staticClass: "ds-dropdown__title", class: t.label ? "caption-500" : "caption-700" }, [t._v(t._s(t.title))]), e("span", { staticClass: "ds-dropdown__value body-500" }, [t._v(t._s(t.label))])]), e("span", { staticClass: "ds-dropdown__open" }, [e("DsIcon", { attrs: { color: "icon-light", name: "system/chevron-down-400" } })], 1)])]), (n = t.error) != null && n.length ? e("div", { staticClass: "ds-dropdown__error caption-500" }, [t._v(t._s(t.error))]) : t.hint || t.$slots.hint ? e("div", { staticClass: "ds-dropdown__hint caption-500" }, [t._v(t._s(t.hint))]) : t._e(), t.custom ? t._e() : e("DsBackdrop", { attrs: { title: t.title, type: "primary" }, model: { value: t.isOpen, callback: function(o) {
    t.isOpen = o;
  }, expression: "isOpen" } }, t._l(t.options, function(o) {
    return e("label", { key: o.label, staticClass: "ds-dropdown__option" }, [e("DsCell", { attrs: { multiline: "" }, scopedSlots: t._u([{ key: "left", fn: function() {
      return [e("DsRadioButton", { attrs: { value: t.value, option: o.value }, on: { input: t.clickValueHandler } })];
    }, proxy: !0 }], null, !0) }, [e("div", { staticClass: "body-500" }, [t._v(t._s(o.label))]), o.caption ? e("div", { staticClass: "ds-dropdown__option-caption caption-500" }, [t._v(t._s(o.caption))]) : t._e()])], 1);
  }), 0)], 1);
}, Va = [], Wa = /* @__PURE__ */ d(
  Ha,
  Na,
  Va,
  !1,
  null,
  "0e2a90e4",
  null,
  null
);
const $d = Wa.exports, De = Object.freeze({
  phone: {
    mask: "+7 (999) 999 99 99",
    placeholder: "",
    showMaskOnHover: !1,
    inputmode: "tel"
  },
  iin: {
    mask: "99 99 99 999 999",
    placeholder: "",
    showMaskOnHover: !1,
    inputmode: "tel"
  },
  currency: {
    alias: "currency",
    placeholder: "",
    digits: 0,
    groupSeparator: " ",
    allowMinus: !1,
    prefix: "",
    suffix: " ₸",
    rightAlign: !1,
    max: 999999999,
    showMaskOnHover: !1,
    showMaskOnFocus: !1
  },
  currencyUsd: {
    alias: "currency",
    placeholder: "",
    digits: 0,
    groupSeparator: " ",
    allowMinus: !1,
    prefix: "",
    suffix: " $",
    rightAlign: !1,
    max: 999999999,
    showMaskOnHover: !1,
    showMaskOnFocus: !1
  },
  date: {
    alias: "datetime",
    inputFormat: "dd.mm.yyyy",
    outputFormat: "dd.mm.yyyy",
    placeholder: "дд.мм.гггг",
    clearIncomplete: !1,
    showMaskOnHover: !1,
    min: "01.01.1900",
    max: "01.01.2100"
  },
  series: { regex: "([a-zA-Z0-9-]+ )*[a-zA-Z0-9-]*" },
  documentNumber: { regex: "([a-zA-Z0-9-]+ )*[a-zA-Z0-9-]*" },
  text: { regex: "[a-zA-ZА-ЯЁӘҒҚҢӨҰҮҺІа-яёәғқңөұүһі -]*" }
});
function ja(s) {
  return typeof s == "string" && Object.keys(De).includes(s) ? new ge(De[s]) : new ge(s);
}
const Ua = {
  components: {
    DsInput: Pa
  },
  props: {
    ...ns,
    mask: {
      type: [String, Object],
      default: void 0
    },
    unmask: Boolean
  },
  emits: [...os],
  data() {
    return { inputMask: null };
  },
  watch: {
    mask() {
      this.mountMask();
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.mountMask();
    });
  },
  methods: {
    mountMask() {
      var t, e, n;
      const s = (e = (t = this.$refs.input) == null ? void 0 : t.$el) == null ? void 0 : e.querySelector("input");
      s && (this.mask ? ja(this.mask).mask(s) : (n = s.inputmask) == null || n.remove());
    },
    onInput(s) {
      var n, o, a;
      const t = (o = (n = this.$refs.input) == null ? void 0 : n.$el) == null ? void 0 : o.querySelector("input"), e = (a = t == null ? void 0 : t.inputmask) == null ? void 0 : a.unmaskedvalue();
      if (s && this.unmask && e) {
        this.$emit("input", e);
        return;
      }
      this.$emit("input", s);
    },
    focus() {
      var s, t;
      (t = (s = this.$refs.input) == null ? void 0 : s.focus) == null || t.call(s);
    },
    blur() {
      var s, t;
      (t = (s = this.$refs.input) == null ? void 0 : s.blur) == null || t.call(s);
    }
  }
};
var Ya = function() {
  var t = this, e = t._self._c;
  return e("DsInput", t._g(t._b({ ref: "input", scopedSlots: t._u([{ key: "prepend", fn: function() {
    return [t._t("prepend")];
  }, proxy: !0 }, { key: "append", fn: function() {
    return [t._t("append")];
  }, proxy: !0 }], null, !0) }, "DsInput", { ...t.$props, ...t.$attrs }, !1), { ...t.$listeners, input: t.onInput }));
}, qa = [], Za = /* @__PURE__ */ d(
  Ua,
  Ya,
  qa,
  !1,
  null,
  null,
  null,
  null
);
const wd = Za.exports;
const rs = {
  value: {
    type: String,
    default: ""
  },
  placeholder: {
    type: String,
    default: ""
  },
  autofocus: Boolean,
  readonly: Boolean
}, as = ["input", "focus", "blur", "click"], Xa = {
  name: "DsInputSearch",
  components: { DsIcon: R },
  props: rs,
  emits: as,
  data() {
    return { focused: !1, stopUseInputHacks: null };
  },
  mounted() {
    this.$nextTick(() => {
      this.stopUseInputHacks = ss(this.$refs.label, this.$refs.input), this.autofocus && !this.readonly && this.focus();
    });
  },
  beforeDestroy() {
    var s;
    (s = this.stopUseInputHacks) == null || s.call(this);
  },
  methods: {
    focus() {
      var s, t;
      (t = (s = this.$refs.input) == null ? void 0 : s.focus) == null || t.call(s);
    },
    blur() {
      var s, t;
      (t = (s = this.$refs.input) == null ? void 0 : s.blur) == null || t.call(s);
    },
    onFocus(s) {
      this.focused = !0, this.$emit("focus", s);
    },
    onBlur(s) {
      var t, e;
      if (this.clearing) {
        this.clearing = !1, (e = (t = this.$refs.input) == null ? void 0 : t.focus) == null || e.call(t);
        return;
      }
      this.focused = !1, this.$emit("blur", s);
    },
    onClear() {
      this.clearing = !0, this.$emit("input", "");
    }
  }
};
var Ga = function() {
  var t = this, e = t._self._c;
  return e("label", { ref: "label", staticClass: "ds-input-search", class: { "ds-input-search--focused": t.focused, "ds-input-search--readonly": t.readonly }, on: { click: function(n) {
    return t.$emit("click", n);
  } } }, [e("DsIcon", { staticClass: "ds-input-search__icon", attrs: { name: "system/search-500", color: "icon-light" } }), e("span", { staticClass: "ds-input-search__input-wrapper" }, [e("input", { ref: "input", staticClass: "ds-input-search__input body-500", attrs: { placeholder: t.placeholder, autofocus: t.autofocus, disabled: t.readonly }, domProps: { value: t.value }, on: { input: function(n) {
    return t.$emit("input", n.target.value);
  }, focus: t.onFocus, blur: t.onBlur } }), t.readonly ? e("span", { staticClass: "ds-input-search__click-trap" }) : t._e()]), t.value && t.focused ? e("button", { staticClass: "ds-input-search__clear", attrs: { type: "button", tabindex: "-1" }, on: { mousedown: t.onClear, click: function(n) {
    n.preventDefault();
  } } }, [e("DsIcon", { attrs: { name: "system/clear-400", color: "icon-light" } })], 1) : t._e()], 1);
}, Ka = [], Ja = /* @__PURE__ */ d(
  Xa,
  Ga,
  Ka,
  !1,
  null,
  "b539668c",
  null,
  null
);
const Qa = Ja.exports, Se = {
  DEFAULT: "default",
  ROUNDED: "rounded",
  SHARP: "sharp"
};
const ti = {
  props: {
    radiusTop: {
      type: String,
      default: "default",
      validator: (s) => Object.values(Se).includes(s)
    },
    radiusBottom: {
      type: String,
      default: "default",
      validator: (s) => Object.values(Se).includes(s)
    },
    alignCenter: Boolean,
    spacingTop: {
      type: String,
      default: ""
    },
    spacingBottom: {
      type: String,
      default: ""
    }
  }
};
var ei = function() {
  var t = this, e = t._self._c;
  return e("section", { staticClass: "ds-island body-500", class: [
    `ds-island--top-${t.radiusTop}`,
    `ds-island--bottom-${t.radiusBottom}`,
    {
      "ds-island--align-center": t.alignCenter,
      [`ds-island--spacing-top-${t.spacingTop}`]: t.spacingTop,
      [`ds-island--spacing-bottom-${t.spacingBottom}`]: t.spacingBottom
    }
  ] }, [t._t("default")], 2);
}, si = [], ni = /* @__PURE__ */ d(
  ti,
  ei,
  si,
  !1,
  null,
  null,
  null,
  null
);
const kd = ni.exports;
const oi = {
  name: "DsIslandsContainer",
  props: {
    spacing: {
      type: String,
      default: "450"
    }
  }
};
var ri = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "ds-islands-container", class: `ds-islands-container--spacing-${t.spacing}` }, [t._t("default")], 2);
}, ai = [], ii = /* @__PURE__ */ d(
  oi,
  ri,
  ai,
  !1,
  null,
  null,
  null,
  null
);
const Dd = ii.exports;
function li(s) {
  const t = `; ${document.cookie}`.split(`; ${s}=`);
  if (t.length === 2)
    return t.pop().split(";").shift();
}
function Te(s, t) {
  const e = parseInt(s);
  Number.isFinite(e) && document.documentElement.style.setProperty("--layout-inset-top", e + "px");
  const n = parseInt(t);
  Number.isFinite(n) && document.documentElement.style.setProperty("--layout-inset-bottom", n + "px");
}
function Re() {
  var e, n, o, a;
  if (!le)
    return;
  const s = (n = (e = li("insets")) == null ? void 0 : e.split) == null ? void 0 : n.call(e, "-");
  (s == null ? void 0 : s.length) === 2 && Te(...s);
  const t = "setSystemBarsHeight";
  window[t] = (r, i) => {
    if (r === "SUCCESS")
      try {
        const l = JSON.parse(i);
        Te(l.statusBarHeight, l.navigationBarHeight);
      } catch {
        console.error("Failed to parse json for system bar height");
      }
  }, (a = (o = window.kaspi) == null ? void 0 : o.send) == null || a.call(o, "getSystemBarHeight", null, t);
}
function jt(s, t) {
  s ? document.documentElement.dataset.iosKeyboard = s : delete document.documentElement.dataset.iosKeyboard;
  const e = (t == null ? void 0 : t.detail) || 0;
  e ? document.documentElement.dataset.iosKeyboardHeight = e : delete document.documentElement.dataset.iosKeyboardHeight;
}
function Be(s) {
  jt("will-show", s);
}
function Oe(s) {
  jt("did-show", s);
}
function Ae(s) {
  jt("will-hide", s);
}
function Ie(s) {
  jt("did-hide", s);
}
function Pe() {
  if (yt)
    return window.addEventListener("keyboardWillShow", Be), window.addEventListener("keyboardDidShow", Oe), window.addEventListener("keyboardWillHide", Ae), window.addEventListener("keyboardDidHide", Ie), () => {
      window.removeEventListener("keyboardWillShow", Be), window.removeEventListener("keyboardDidShow", Oe), window.removeEventListener("keyboardWillHide", Ae), window.removeEventListener("keyboardDidHide", Ie);
    };
}
const ci = {
  name: "DsLayout",
  props: {
    hideInsetTop: Boolean
  },
  data() {
    return {
      keyboardCallbackOnIos: null
    };
  },
  created() {
    nn(), Re(), this.keyboardCallbackOnIos = Pe();
  },
  updated() {
    Re(), this.keyboardCallbackOnIos && this.keyboardCallbackOnIos(), this.keyboardCallbackOnIos = Pe();
  },
  beforeDestroy() {
    this.keyboardCallbackOnIos && this.keyboardCallbackOnIos();
  }
};
var ui = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "ds-layout", class: {
    "ds-layout--no-header": !t.$slots.header,
    "ds-layout--hide-inset-top": t.hideInsetTop
  } }, [e("div", { staticClass: "ds-layout__header" }, [t._t("header")], 2), e("div", { staticClass: "ds-layout__body" }, [t._t("default")], 2)]);
}, di = [], _i = /* @__PURE__ */ d(
  ci,
  ui,
  di,
  !1,
  null,
  null,
  null,
  null
);
const fi = _i.exports, Z = Object.freeze({
  LARGE: "large",
  MEDIUM: "medium",
  SMALL: "small"
});
const pi = {
  [Z.LARGE]: "label-600-soft",
  [Z.MEDIUM]: "label-500-soft",
  [Z.SMALL]: "label-500-soft"
}, vi = {
  name: "DsLinkCell",
  components: {
    DsContainer: S,
    DsIcon: R
  },
  props: {
    size: {
      type: String,
      default: Z.MEDIUM,
      validator: (s) => Object.values(Z).includes(s)
    },
    tag: {
      type: String,
      default: "button"
    }
  },
  emits: ["click"],
  computed: {
    textSizeClass() {
      return pi[this.size];
    }
  }
};
var mi = function() {
  var t = this, e = t._self._c;
  return e("DsContainer", { staticClass: "ds-link-cell", class: `ds-link-cell--${t.size}`, attrs: { tag: t.tag }, nativeOn: { click: function(n) {
    return t.$emit("click", n);
  } } }, [e("span", { staticClass: "ds-link-cell__text", class: t.textSizeClass }, [t._t("default")], 2), e("DsIcon", { staticClass: "ds-link-cell__icon", attrs: { name: "chevron-right-400" } })], 1);
}, hi = [], gi = /* @__PURE__ */ d(
  vi,
  mi,
  hi,
  !1,
  null,
  "5d9e2c32",
  null,
  null
);
const Sd = gi.exports;
const bi = {
  [Z.LARGE]: "label-600",
  [Z.MEDIUM]: "label-500",
  [Z.SMALL]: "label-400"
}, yi = {
  name: "DsLinkDefault",
  components: { DsIcon: R },
  props: {
    size: {
      type: String,
      default: Z.MEDIUM
    },
    icon: {
      type: String,
      default: ""
    },
    tag: {
      type: String,
      default: "button"
    }
  },
  emits: ["click"],
  computed: {
    sizeClass() {
      return bi[this.size];
    }
  }
};
var xi = function() {
  var t = this, e = t._self._c;
  return e(t.tag, { tag: "component", staticClass: "ds-link-default", class: t.sizeClass, on: { click: function(n) {
    return t.$emit("click", n);
  } } }, [t.icon ? e("DsIcon", { staticClass: "ds-link-default__icon", attrs: { name: t.icon } }) : t._e(), t._t("default")], 2);
}, Ci = [], $i = /* @__PURE__ */ d(
  yi,
  xi,
  Ci,
  !1,
  null,
  null,
  null,
  null
);
const wi = $i.exports;
const Bt = 0, Jt = 100, ki = {
  name: "DsLoader",
  components: { DsContainer: S },
  props: {
    progress: {
      type: Number,
      required: !0,
      validator(s) {
        return s >= Bt && s <= Jt;
      }
    }
  },
  data() {
    return {
      radius: 48
    };
  },
  computed: {
    currentProgress() {
      return typeof this.progress != "number" || this.progress < Bt ? Bt : this.progress > Jt ? Jt : this.progress;
    },
    arcLength() {
      return 2 * Math.PI * this.radius;
    },
    arcOffset() {
      return this.arcLength * (1 - this.currentProgress / 100);
    }
  }
};
var Di = function() {
  var t = this, e = t._self._c;
  return e("DsContainer", { staticClass: "ds-loader" }, [e("div", { staticClass: "ds-loader__wrapper heading-500-accent" }, [e("span", { staticClass: "ds-loader__text" }, [t._v(t._s(t.currentProgress) + "%")]), e("svg", { staticClass: "ds-loader__spinner", attrs: { width: "100%", height: "100%" } }, [e("circle", { staticClass: "ds-loader__track", attrs: { "stroke-width": "0.25rem", cx: "50%", cy: "50%", r: "48%" } }), e("circle", { staticClass: "ds-loader__indicator", attrs: { "stroke-width": "0.27rem", cx: "50%", cy: "50%", r: t.radius + "%", "stroke-dasharray": t.arcLength + "%", "stroke-dashoffset": t.arcOffset + "%" } })])]), t.$slots.title ? e("div", { staticClass: "ds-loader__title heading-200-accent" }, [t._t("title")], 2) : t._e(), t.$slots.subtitle ? e("div", { staticClass: "ds-loader__subtitle body-500" }, [t._t("subtitle")], 2) : t._e()]);
}, Si = [], Ti = /* @__PURE__ */ d(
  ki,
  Di,
  Si,
  !1,
  null,
  "22af4d9c",
  null,
  null
);
const Td = Ti.exports;
const Ri = {
  __name: "DsNavBar",
  props: {
    transparent: Boolean
  },
  setup(s) {
    const t = h(null), e = h(null), n = new MutationObserver(o);
    j(() => {
      o(), [t.value, e.value].forEach((r) => {
        r instanceof HTMLElement && n.observe(r, { childList: !0 });
      });
    }), re(() => {
      n.disconnect();
    });
    function o() {
      t.value.style.minWidth = "auto", e.value.style.minWidth = "auto", kt(() => {
        const a = t.value.getBoundingClientRect().width, r = e.value.getBoundingClientRect().width;
        t.value.style.minWidth = `${Math.max(a, r)}px`, e.value.style.minWidth = `${Math.max(a, r)}px`;
      });
    }
    return { __sfc: !0, leftRef: t, rightRef: e, slotObserver: n, updateMaxSlotWidth: o, DsContainer: S };
  }
};
var Bi = function() {
  var t = this, e = t._self._c, n = t._self._setupProxy;
  return e(n.DsContainer, { staticClass: "ds-navbar", class: { "ds-navbar--transparent": t.transparent }, attrs: { tag: "header" } }, [e("div", { ref: "leftRef", staticClass: "ds-navbar__left" }, [t._t("left")], 2), e("div", { staticClass: "ds-navbar__center" }, [e("div", { staticClass: "ds-navbar__title static-title-500-heavy" }, [t._t("default")], 2), t.$slots.subtitle ? e("div", { staticClass: "ds-navbar__subtitle static-caption-500" }, [t._t("subtitle")], 2) : t._e()]), e("div", { ref: "rightRef", staticClass: "ds-navbar__right" }, [t._t("right")], 2)]);
}, Oi = [], Ai = /* @__PURE__ */ d(
  Ri,
  Bi,
  Oi,
  !1,
  null,
  "44470516",
  null,
  null
);
const Ii = Ai.exports, Pi = /* @__PURE__ */ k({
  __name: "DsNavButton",
  emits: ["click"],
  setup(s, { emit: t }) {
    const { setBackAnimation: e } = F(qe, { setBackAnimation: () => {
    } });
    function n(o) {
      e(), t("click", o);
    }
    return { __sfc: !0, emit: t, setBackAnimation: e, onClick: n };
  }
});
var Ei = function() {
  var t = this, e = t._self._c, n = t._self._setupProxy;
  return e("button", { staticClass: "ds-nav-button", on: { click: n.onClick } }, [t._t("default")], 2);
}, Li = [], Fi = /* @__PURE__ */ d(
  Pi,
  Ei,
  Li,
  !1,
  null,
  null,
  null,
  null
);
const Mi = Fi.exports;
let Ee = 0;
const zi = {
  components: {
    DsSpinner: Vt
  },
  props: {
    isPullDown: {
      type: Boolean,
      required: !0
    },
    isSpinning: {
      type: Boolean,
      required: !1
    },
    topOffset: {
      type: Number,
      required: !0
    },
    color: {
      type: String,
      default: "icon-inverse"
    },
    size: {
      type: String,
      default: "s"
    }
  },
  data: function() {
    return {
      hasAnimation: !1
    };
  },
  watch: {
    isPullDown() {
      this.$refs.pullRef && (this.$props.isPullDown ? this.$refs.pullRef.style.opacity = 1 : (this.hasAnimation = !0, clearTimeout(Ee), Ee = setTimeout(() => {
        this.hasAnimation = !1;
      }, 400), this.$refs.pullRef.style.opacity = 0));
    }
  }
};
var Hi = function() {
  var t = this, e = t._self._c;
  return e("div", { ref: "pullRef", staticClass: "ds-pull-controller", class: { "ds-pull-controller--transition": t.hasAnimation }, style: { height: `${t.isPullDown ? t.topOffset : 0}px` } }, [t._t("default", function() {
    return [e("DsSpinner", { attrs: { color: t.color, size: t.size, "is-spinning": t.isSpinning } })];
  })], 2);
}, Ni = [], Vi = /* @__PURE__ */ d(
  zi,
  Hi,
  Ni,
  !1,
  null,
  "de4e0da7",
  null,
  null
);
const Rd = Vi.exports;
const Wi = {
  name: "DsResultBanner",
  components: { DsContainer: S, DsStatusIcon: Dt },
  props: {
    type: {
      type: String,
      default: "success"
    },
    title: {
      type: String,
      default: ""
    },
    accentText: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    animated: Boolean
  },
  setup(s) {
    const t = {
      success: "success",
      neutral: "info",
      negative: "error"
    };
    return {
      statusIconType: x(() => t[s.type] || {})
    };
  }
};
var ji = function() {
  var t = this, e = t._self._c;
  return e("DsContainer", { staticClass: "ds-result-banner" }, [e("DsStatusIcon", { staticClass: "ds-result-banner__icon", attrs: { size: "large", type: t.statusIconType, animated: t.animated } }), t.title || t.$slots.title ? e("div", { staticClass: "ds-result-banner__title heading-200-accent" }, [t._t("title", function() {
    return [t._v(t._s(t.title))];
  })], 2) : t._e(), t.accentText || t.$slots.accentText ? e("div", { staticClass: "ds-result-banner__accent-text heading-500-accent" }, [t._t("accentText", function() {
    return [t._v(t._s(t.accentText))];
  })], 2) : t._e(), t.text || t.$slots.text ? e("div", { staticClass: "ds-result-banner__text-block body-700" }, [t._t("text", function() {
    return [t._v(t._s(t.text))];
  })], 2) : t._e(), t.description || t.$slots.description ? e("div", { staticClass: "ds-result-banner__description body-500" }, [t._t("description", function() {
    return [t._v(t._s(t.description))];
  })], 2) : t._e()], 1);
}, Ui = [], Yi = /* @__PURE__ */ d(
  Wi,
  ji,
  Ui,
  !1,
  null,
  null,
  null,
  null
);
const Bd = Yi.exports;
const qi = {
  name: "DsSearchBar",
  components: {
    DsContainer: S,
    DsInputSearch: Qa
  },
  props: {
    ...Ht,
    ...rs
  },
  emits: [...as],
  methods: {
    focus() {
      var s, t;
      (t = (s = this.$refs.input) == null ? void 0 : s.focus) == null || t.call(s);
    },
    blur() {
      var s, t;
      (t = (s = this.$refs.input) == null ? void 0 : s.blur) == null || t.call(s);
    }
  }
};
var Zi = function() {
  var t = this, e = t._self._c;
  return e("DsContainer", { staticClass: "ds-search-bar", attrs: { tag: t.tag } }, [t._t("left"), e("DsInputSearch", { ref: "input", staticClass: "ds-search-bar__input", attrs: { value: t.value, placeholder: t.placeholder, autofocus: t.autofocus, readonly: t.readonly }, on: { input: function(n) {
    return t.$emit("input", n);
  }, focus: function(n) {
    return t.$emit("focus", n);
  }, blur: function(n) {
    return t.$emit("blur", n);
  }, click: function(n) {
    return t.$emit("click", n);
  } } }), t._t("right")], 2);
}, Xi = [], Gi = /* @__PURE__ */ d(
  qi,
  Zi,
  Xi,
  !1,
  null,
  "7e23f3a7",
  null,
  null
);
const Od = Gi.exports;
const Ki = {
  name: "DsSearchBarButton"
};
var Ji = function() {
  var t = this, e = t._self._c;
  return e("button", { staticClass: "ds-search-bar-button", on: { click: function(n) {
    return t.$emit("click", n);
  } } }, [t._t("default")], 2);
}, Qi = [], tl = /* @__PURE__ */ d(
  Ki,
  Ji,
  Qi,
  !1,
  null,
  "4d6b6a93",
  null,
  null
);
const Ad = tl.exports, is = Symbol("segments-injection-key"), el = 60, sl = 5, nl = /* @__PURE__ */ k({
  __name: "DsSegmentedControlItems",
  props: {
    active: null,
    count: null,
    isTouching: { type: Boolean },
    height: null
  },
  emits: ["slide", "on-touch", "change"],
  setup(s, { emit: t }) {
    const e = s;
    let n = window.innerWidth, o = !1, a = 0;
    const r = h(0), i = h(0), l = h(null), c = h(0), u = h("auto"), _ = x(() => i.value - r.value);
    j(() => {
      c.value = n * e.active * -1, setTimeout(() => {
        if (l.value) {
          const m = l.value.getBoundingClientRect();
          u.value = `${Math.max(m.height, e.height)}px`, n = m.width || window.innerWidth;
        }
      });
    }), O(
      () => _.value,
      (m) => {
        t("slide", m), c.value = Math.round(m - e.active * n);
      }
    ), O(
      () => e.isTouching,
      (m) => {
        document.body.style.overflow = m ? "hidden" : "";
      }
    ), O(
      () => e.active,
      (m) => {
        c.value = n * m * -1;
      }
    );
    function p(m) {
      r.value = m.touches[0].clientX, a = m.touches[0].clientY, i.value = m.touches[0].clientX;
    }
    function f(m) {
      if (o)
        return;
      const C = m.touches[0].clientX - r.value, b = m.touches[0].clientY - a;
      if (Math.abs(b) > sl && !e.isTouching || r.value < 30) {
        o = !0;
        return;
      }
      const w = e.active === 0 && C >= 0, D = e.active === e.count - 1 && e.active * n - C >= e.active * n;
      w || D || (t("on-touch", !0), kt(() => {
        m.preventDefault(), m.stopPropagation(), i.value = m.touches[0].clientX;
      }));
    }
    function v() {
      o = !1, t("on-touch", !1), Math.abs(i.value - r.value) > el ? g() : y();
    }
    function y() {
      i.value = r.value;
    }
    function g() {
      i.value = i.value > r.value ? n : n * -1, r.value = 0;
      const m = i.value > r.value ? -1 : 1;
      t("change", e.active + m), i.value = 0;
    }
    return { __sfc: !0, props: e, emit: t, containerWidth: n, isTouchBlocked: o, startTouchPositionY: a, startTouchPositionX: r, currentTouchPositionX: i, containerRef: l, translateX: c, containerHeight: u, touchOffsetX: _, onTouchStart: p, onTouchMove: f, onTouchEnd: v, restorePosition: y, swapItem: g };
  }
});
var ol = function() {
  var t = this, e = t._self._c, n = t._self._setupProxy;
  return e("div", { ref: "containerRef", staticClass: "ds-segmented-control-items" }, [e("div", { staticClass: "ds-segmented-control-items__content", class: { "ds-segmented-control-items__content--on-touch": t.isTouching }, style: { transform: `translateX(${n.translateX}px)`, height: n.containerHeight }, on: { touchstart: n.onTouchStart, touchend: n.onTouchEnd, touchmove: n.onTouchMove } }, [t._t("default")], 2)]);
}, rl = [], al = /* @__PURE__ */ d(
  nl,
  ol,
  rl,
  !1,
  null,
  null,
  null,
  null
);
const il = al.exports, ll = /* @__PURE__ */ k({
  __name: "DsSegmentedControlTabs",
  props: {
    active: null,
    count: null,
    offset: { default: 0 },
    fixed: { type: Boolean },
    isTouching: { type: Boolean, default: !1 }
  },
  setup(s) {
    const t = s, e = h(null), n = h(null), o = h(0), a = h(0), r = x(() => t.active * o.value - t.offset / t.count);
    j(() => {
      kt(() => {
        i(), t.fixed && l();
      });
    });
    function i() {
      if (!n.value)
        return;
      const c = n.value.getBoundingClientRect();
      o.value = c.width / t.count;
    }
    function l() {
      var c;
      if ((c = e.value) != null && c.$el) {
        const u = e.value.$el.getBoundingClientRect();
        a.value = u.height;
      }
    }
    return { __sfc: !0, props: t, containerRef: e, tabsRef: n, sliderWidth: o, tabsHeight: a, translateX: r, setSliderWidth: i, setTabsHeight: l, DsContainer: S };
  }
});
var cl = function() {
  var t = this, e = t._self._c, n = t._self._setupProxy;
  return e("div", { style: { height: n.tabsHeight ? `${n.tabsHeight}px` : "auto" } }, [e(n.DsContainer, { ref: "containerRef", class: [
    "ds-segmented-control-tabs__container py-400",
    {
      "ds-segmented-control-tabs__container--fixed": t.fixed
    }
  ] }, [e("div", { directives: [{ name: "show", rawName: "v-show", value: t.count > 0, expression: "count > 0" }], staticClass: "ds-segmented-control-tabs" }, [e("div", { ref: "tabsRef", staticClass: "ds-segmented-control-tabs__wrapper" }, [t._t("default"), e("div", { staticClass: "ds-segmented-control-tabs__slider", class: {
    "ds-segmented-control-tabs__slider--on-touch": t.isTouching
  }, style: { transform: `translateX(${n.translateX}px)`, width: `${n.sliderWidth}px` } })], 2)])])], 1);
}, ul = [], dl = /* @__PURE__ */ d(
  ll,
  cl,
  ul,
  !1,
  null,
  "eda1033d",
  null,
  null
);
const _l = dl.exports;
const fl = {
  setup(s, { emit: t }) {
    function e() {
      t("tap");
    }
    return {
      onTap: e
    };
  }
};
var pl = function() {
  var t = this, e = t._self._c;
  return e("button", { staticClass: "ds-segmented-control-tab label-500-soft", on: { click: t.onTap } }, [e("div", { staticClass: "line-clamp" }, [t._t("default")], 2)]);
}, vl = [], ml = /* @__PURE__ */ d(
  fl,
  pl,
  vl,
  !1,
  null,
  "293148af",
  null,
  null
);
const hl = ml.exports, gl = /* @__PURE__ */ k({
  __name: "DsSegmentedControl",
  props: {
    value: { default: 0 },
    full: { type: Boolean, default: !1 },
    fixedTabs: { type: Boolean, default: !1 }
  },
  emits: ["input"],
  setup(s, { emit: t }) {
    const e = s, n = h(0), o = h(e.value), a = h([]), r = h(!0), i = h(0), l = h(0), c = {
      count: n,
      active: o,
      height: l,
      full: e.full,
      incrementCount: u,
      addTab: p,
      setMaxHeight: y
    };
    ot(is, c), O(
      () => o.value,
      (g) => {
        t("input", g);
      }
    ), O(
      () => e.value,
      (g) => {
        g >= 0 && g < n.value && (o.value = g);
      }
    ), j(() => {
      setTimeout(() => {
        r.value = !1;
      });
    });
    function u() {
      n.value++;
    }
    function _(g) {
      o.value = g;
    }
    function p(g) {
      a.value.push(g);
    }
    function f(g) {
      r.value = g;
    }
    function v(g) {
      i.value = g;
    }
    function y(g) {
      l.value = g;
    }
    return { __sfc: !0, props: e, emit: t, count: n, active: o, tabs: a, isTouching: r, offset: i, height: l, provideData: c, incrementCount: u, setActive: _, addTab: p, setTouchState: f, setTouchOffset: v, setMaxHeight: y, DsSegmentedControlItems: il, DsSegmentedControlTabs: _l, DsSegmentedControlTab: hl };
  }
});
var bl = function() {
  var t = this, e = t._self._c, n = t._self._setupProxy;
  return e("div", { staticClass: "ds-segmented-control", class: {
    "ds-segmented-control--full": t.full
  } }, [e(n.DsSegmentedControlTabs, { attrs: { count: n.tabs.length, active: n.active, offset: n.offset, "is-touching": n.isTouching, fixed: t.fixedTabs } }, t._l(n.tabs, function(o, a) {
    return e(n.DsSegmentedControlTab, { key: o, on: { tap: function(r) {
      return n.setActive(a);
    } } }, [t._v(" " + t._s(o) + " ")]);
  }), 1), e(n.DsSegmentedControlItems, { attrs: { active: n.active, count: n.tabs.length, "is-touching": n.isTouching, height: n.height }, on: { change: n.setActive, "on-touch": n.setTouchState, slide: n.setTouchOffset } }, [t._t("default")], 2)], 1);
}, yl = [], xl = /* @__PURE__ */ d(
  gl,
  bl,
  yl,
  !1,
  null,
  null,
  null,
  null
);
const Id = xl.exports, Cl = /* @__PURE__ */ k({
  __name: "DsSegmentedControlItem",
  props: {
    title: null,
    scrollable: { type: Boolean, default: !1 }
  },
  setup(s) {
    const t = s, e = F(is, null), n = h(null), o = h(null), a = h(0), r = h(0), i = x(() => e == null ? void 0 : e.active.value), l = x(() => i.value === r.value);
    ae(() => {
      if (e === null)
        throw new Error("No injection key found");
      r.value = e.count.value, e.incrementCount(), e.addTab(t.title);
    }), j(() => {
      c(), setTimeout(() => {
        const u = n.value;
        !u || !e || (!t.scrollable && u.scrollHeight > e.height.value && e.setMaxHeight(u.scrollHeight), u.style.position = "absolute");
      });
    }), O(
      () => l.value,
      (u) => {
        u && c();
      }
    );
    function c() {
      setTimeout(() => {
        const u = o.value;
        u && (a.value = u.getBoundingClientRect().height, u.style.position = "fixed");
      });
    }
    return { __sfc: !0, controller: e, props: t, segmentItemRef: n, btnBarRef: o, btnBarHeight: a, index: r, activeIndex: i, isActive: l, setBtnBarHeight: c, DsButtonBar: Ao, DsPortal: ce };
  }
});
var $l = function() {
  var t = this, e = t._self._c, n = t._self._setupProxy;
  return e("div", { ref: "segmentItemRef", staticClass: "ds-segmented-control-item body-500", class: {
    "ds-segmented-control-item--active": n.isActive,
    "ds-segmented-control-item--scrollable": t.scrollable
  }, style: { transform: `translate(${n.index * 100}%)` } }, [t._t("default"), e("div", { style: { paddingTop: `${n.btnBarHeight}px` } }), t.$slots.buttons ? e(n.DsPortal, { attrs: { to: ".ds-layout__body" } }, [e("div", { directives: [{ name: "show", rawName: "v-show", value: n.isActive, expression: "isActive" }], ref: "btnBarRef", staticClass: "ds-segmented-control-item__button-bar" }, [e(n.DsButtonBar, [t._t("buttons")], 2)], 1)]) : t._e()], 2);
}, wl = [], kl = /* @__PURE__ */ d(
  Cl,
  $l,
  wl,
  !1,
  null,
  null,
  null,
  null
);
const Pd = kl.exports, Dl = {};
var Sl = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "ds-segment-spacer", staticStyle: { "flex-grow": "1 !important" } });
}, Tl = [], Rl = /* @__PURE__ */ d(
  Dl,
  Sl,
  Tl,
  !1,
  null,
  null,
  null,
  null
);
const Ed = Rl.exports;
const Bl = {
  components: { DsSpinner: Vt, DsOverlay: ue },
  props: {
    visible: Boolean
  },
  emits: ["click:overlay"]
};
var Ol = function() {
  var t = this, e = t._self._c;
  return e("DsOverlay", { attrs: { visible: t.visible }, on: { "click:overlay": function(n) {
    return t.$emit("click:overlay", n);
  } } }, [e("div", { staticClass: "ds-spinner-modal" }, [e("div", { staticClass: "ds-spinner-modal__spinner" }, [e("DsSpinner", { attrs: { size: "s", "is-spinning": "" } })], 1), t.$slots.title ? e("div", { staticClass: "ds-spinner-modal__text" }, [e("div", { staticClass: "ds-spinner-modal__title title-500-heavy" }, [t._t("title")], 2), t.$slots.description ? e("div", { staticClass: "ds-spinner-modal__description body-300" }, [t._t("description")], 2) : t._e()]) : t._e()])]);
}, Al = [], Il = /* @__PURE__ */ d(
  Bl,
  Ol,
  Al,
  !1,
  null,
  "209b5552",
  null,
  null
);
const Ld = Il.exports;
const Pl = {
  __name: "DsStepper",
  props: {
    steps: {
      type: Number,
      required: !0
    },
    progress: {
      type: Number,
      default: -1
    }
  },
  setup(s) {
    return { __sfc: !0, DsContainer: S, DsStatusIcon: Dt };
  }
};
var El = function() {
  var t = this, e = t._self._c, n = t._self._setupProxy;
  return e(n.DsContainer, { staticClass: "ds-stepper body-500", class: {
    "ds-stepper--progress": t.progress >= 0
  }, attrs: { tag: "ul" } }, t._l(t.steps, function(o) {
    return e("li", { key: o, staticClass: "ds-stepper__step", class: {
      "ds-stepper__step--blank": t.progress >= o
    } }, [e("div", { staticClass: "ds-stepper__step_number" }, [e("svg", { staticClass: "ds-stepper__step_line", attrs: { height: "100%", width: "2px" } }, [e("line", { attrs: { x1: "1", y1: "0", x2: "1", y2: "100%", "stroke-dasharray": "1,4", stroke: "currentColor", "stroke-linecap": "round", "stroke-width": "2" } })]), t.progress < 0 ? [t._v(" " + t._s(o) + " ")] : t.progress >= o ? [e(n.DsStatusIcon, { attrs: { type: "success" } })] : t._e()], 2), e("div", { staticClass: "ds-stepper__step_content" }, [t._t(`step-${o}`)], 2)]);
  }), 0);
}, Ll = [], Fl = /* @__PURE__ */ d(
  Pl,
  El,
  Ll,
  !1,
  null,
  "9786ae7b",
  null,
  null
);
const Fd = Fl.exports, Ut = Symbol("stepper-injection-key"), Ml = /* @__PURE__ */ k({
  __name: "DsStepNumber",
  setup(s) {
    const t = h(0), e = F(Ut, null);
    return j(() => {
      e && (e.incrementCount(), t.value = e.count.value);
    }), { __sfc: !0, index: t, data: e };
  }
});
var zl = function() {
  var t = this, e = t._self._c, n = t._self._setupProxy;
  return e("li", { staticClass: "ds-step-number" }, [e("div", { staticClass: "ds-step-number__indicator" }, [e("svg", { staticClass: "ds-step-number__line", attrs: { height: "100%", width: "2px" } }, [e("line", { attrs: { x1: "1", y1: "0", x2: "1", y2: "100%", "stroke-dasharray": "1,4", stroke: "currentColor", "stroke-linecap": "round", "stroke-width": "2" } })]), t._v(" " + t._s(n.index) + " ")]), e("div", { staticClass: "ds-step-number__content" }, [t._t("default")], 2)]);
}, Hl = [], Nl = /* @__PURE__ */ d(
  Ml,
  zl,
  Hl,
  !1,
  null,
  null,
  null,
  null
);
const Md = Nl.exports, Vl = /* @__PURE__ */ k({
  __name: "DsStepperNumber",
  setup(s) {
    const t = {
      count: h(0),
      incrementCount() {
        this.count.value++;
      }
    };
    return ot(Ut, t), { __sfc: !0, provideData: t, DsContainer: S };
  }
});
var Wl = function() {
  var t = this, e = t._self._c, n = t._self._setupProxy;
  return e(n.DsContainer, { staticClass: "ds-stepper-number", attrs: { tag: "ul" } }, [t._t("default")], 2);
}, jl = [], Ul = /* @__PURE__ */ d(
  Vl,
  Wl,
  jl,
  !1,
  null,
  null,
  null,
  null
);
const zd = Ul.exports, Yl = /* @__PURE__ */ k({
  __name: "DsStepProgress",
  setup(s) {
    const t = h(0), e = F(Ut, null);
    j(() => {
      a();
    });
    const n = x(() => {
      var r;
      return ((r = e == null ? void 0 : e.active) == null ? void 0 : r.value) || -1;
    }), o = x(() => n.value >= t.value);
    function a() {
      e && (e.incrementCount(), t.value = e.count.value);
    }
    return { __sfc: !0, index: t, data: e, progress: n, isActive: o, setIndex: a, DsStatusIcon: Dt };
  }
});
var ql = function() {
  var t = this, e = t._self._c, n = t._self._setupProxy;
  return e("li", { staticClass: "ds-step-progress", class: {
    "ds-step-progress--active": n.isActive
  } }, [e("div", { staticClass: "ds-step-progress__indicator" }, [e("svg", { staticClass: "ds-step-progress__line", attrs: { height: "100%", width: "2px" } }, [e("line", { attrs: { x1: "1", y1: "0", x2: "1", y2: "100%", "stroke-dasharray": "1,4", stroke: "currentColor", "stroke-linecap": "round", "stroke-width": "2" } })]), n.isActive ? e(n.DsStatusIcon, { attrs: { type: "success" } }) : t._e()], 1), e("div", { staticClass: "ds-step-progress__content" }, [t._t("default")], 2)]);
}, Zl = [], Xl = /* @__PURE__ */ d(
  Yl,
  ql,
  Zl,
  !1,
  null,
  null,
  null,
  null
);
const Hd = Xl.exports, Gl = /* @__PURE__ */ k({
  __name: "DsStepperProgress",
  props: {
    activeIndex: null
  },
  setup(s) {
    const t = s, e = {
      active: x(() => t.activeIndex),
      count: h(0),
      incrementCount() {
        this.count.value++;
      }
    };
    return ot(Ut, e), { __sfc: !0, props: t, provideData: e, DsContainer: S };
  }
});
var Kl = function() {
  var t = this, e = t._self._c, n = t._self._setupProxy;
  return e(n.DsContainer, { staticClass: "ds-stepper-number", attrs: { tag: "ul" } }, [t._t("default")], 2);
}, Jl = [], Ql = /* @__PURE__ */ d(
  Gl,
  Kl,
  Jl,
  !1,
  null,
  null,
  null,
  null
);
const Nd = Ql.exports, St = Symbol("table-provide-payload"), Vd = ["small", "large"], Wd = ["left", "center", "right"], tc = /* @__PURE__ */ k({
  __name: "DsTable",
  props: {
    size: { default: "large" },
    textAlign: { default: "left" },
    bordered: { type: Boolean, default: !1 }
  },
  setup(s) {
    const t = s, e = xs(Cs(t, "size")), n = h(!1);
    let o = !1;
    ot(St, { size: e, vertical: n, setHeaderPresence: l });
    const a = new MutationObserver(i), r = h(null);
    j(() => {
      i(), r.value && a.observe(r.value, { childList: !0, subtree: !0 });
    }), re(() => {
      a.disconnect();
    });
    function i() {
      const u = r.value;
      u && (u.style.tableLayout = "auto", kt(() => {
        u.scrollWidth + u.offsetLeft * 2 <= window.innerWidth ? u.style.tableLayout = "fixed" : c(u);
      }));
    }
    function l() {
      o = !0;
    }
    function c(u) {
      const _ = u.querySelector("tr");
      if (!_)
        return;
      const p = _.children.length;
      n.value = p === 2 && !o;
    }
    return { __sfc: !0, props: t, size: e, isVerticalAligned: n, hasHeader: o, observer: a, tableRef: r, setTableLayout: i, setHeaderPresence: l, setColumnAlignment: c, DsContainer: S };
  }
});
var ec = function() {
  var t = this, e = t._self._c, n = t._self._setupProxy;
  return e(n.DsContainer, { staticClass: "ds-table", class: [{ "ds-table--bordered": t.bordered }, `ds-table--text-${t.textAlign}`] }, [e("table", { ref: "tableRef" }, [t._t("default", null, { textSize: n.size })], 2)]);
}, sc = [], nc = /* @__PURE__ */ d(
  tc,
  ec,
  sc,
  !1,
  null,
  null,
  null,
  null
);
const jd = nc.exports, oc = /* @__PURE__ */ k({
  __name: "DsTableCell",
  setup(s) {
    const { size: t } = F(St, { size: h("large") });
    return { __sfc: !0, size: t };
  }
});
var rc = function() {
  var t = this, e = t._self._c, n = t._self._setupProxy;
  return e("td", { staticClass: "ds-table-cell", class: `ds-table-cell--${n.size}` }, [t.$slots.subhead ? e("div", { staticClass: "ds-table-cell__subhead", class: n.size === "large" ? "caption-700" : "caption-600" }, [t._t("subhead")], 2) : t._e(), t.$slots.default ? e("div", { staticClass: "ds-table-cell__value", class: n.size === "large" ? "body-500" : "body-400" }, [t._t("default")], 2) : t._e(), t.$slots.caption ? e("div", { staticClass: "ds-table-cell__caption", class: n.size === "large" ? "caption-700" : "caption-600" }, [t._t("caption")], 2) : t._e()]);
}, ac = [], ic = /* @__PURE__ */ d(
  oc,
  rc,
  ac,
  !1,
  null,
  "1fbc65ef",
  null,
  null
);
const Ud = ic.exports, lc = /* @__PURE__ */ k({
  __name: "DsTableColumn",
  setup(s) {
    const { size: t } = F(St, { size: h("large") });
    return { __sfc: !0, size: t };
  }
});
var cc = function() {
  var t = this, e = t._self._c, n = t._self._setupProxy;
  return e("td", { staticClass: "ds-table-cell", class: `ds-table-cell--${n.size}` }, [t.$slots.subhead ? e("div", { staticClass: "ds-table-cell__subhead", class: n.size === "large" ? "caption-700" : "caption-600" }, [t._t("subhead")], 2) : t._e(), t.$slots.default ? e("div", { staticClass: "ds-table-cell__value", class: n.size === "large" ? "body-500" : "body-400" }, [t._t("default")], 2) : t._e(), t.$slots.caption ? e("div", { staticClass: "ds-table-cell__caption", class: n.size === "large" ? "caption-700" : "caption-600" }, [t._t("caption")], 2) : t._e()]);
}, uc = [], dc = /* @__PURE__ */ d(
  lc,
  cc,
  uc,
  !1,
  null,
  "b221f734",
  null,
  null
);
const Yd = dc.exports, _c = /* @__PURE__ */ k({
  __name: "DsTableHeader",
  setup(s) {
    const { size: t, setHeaderPresence: e } = F(St, {
      size: h("large"),
      setHeaderPresence: () => {
      }
    });
    return j(() => {
      e && e();
    }), { __sfc: !0, size: t, setHeaderPresence: e };
  }
});
var fc = function() {
  var t = this, e = t._self._c, n = t._self._setupProxy;
  return e("th", { staticClass: "ds-table-header", class: n.size === "large" ? "title-500-accent" : "title-400-soft" }, [t._t("default")], 2);
}, pc = [], vc = /* @__PURE__ */ d(
  _c,
  fc,
  pc,
  !1,
  null,
  null,
  null,
  null
);
const qd = vc.exports, mc = /* @__PURE__ */ k({
  __name: "DsTableRow",
  setup(s) {
    const { vertical: t } = F(St, { vertical: h(!1) });
    return { __sfc: !0, vertical: t };
  }
});
var hc = function() {
  var t = this, e = t._self._c, n = t._self._setupProxy;
  return e("tr", { staticClass: "ds-table-row", class: {
    "ds-table-row--vertical": n.vertical
  } }, [t._t("default")], 2);
}, gc = [], bc = /* @__PURE__ */ d(
  mc,
  hc,
  gc,
  !1,
  null,
  null,
  null,
  null
);
const Zd = bc.exports;
const yc = {
  name: "DsTitle",
  components: { DsContainer: S },
  props: {
    size: {
      type: String,
      default: "h1"
    }
  }
};
var xc = function() {
  var t = this, e = t._self._c;
  return e("DsContainer", { staticClass: "ds-title" }, [e("div", { staticClass: "ds-title__main" }, [e("div", { staticClass: "ds-title__main_text", class: {
    "title-700-heavy": t.size === "h1",
    "title-600-heavy": t.size === "h2",
    "title-500-heavy": t.size === "h3"
  } }, [t._t("default")], 2), t.$slots.subtitle ? e("div", { staticClass: "ds-title__main_subtitle", class: {
    "ds-title__main_subtitle--h1 caption-700": t.size === "h1",
    "ds-title__main_subtitle--h2 caption-700": t.size === "h2",
    "ds-title__main_subtitle--h3 caption-600": t.size === "h3"
  } }, [t._t("subtitle")], 2) : t._e()]), t.$slots.tail ? e("div", { staticClass: "ds-title__tail label-600" }, [t._t("tail")], 2) : t._e()]);
}, Cc = [], $c = /* @__PURE__ */ d(
  yc,
  xc,
  Cc,
  !1,
  null,
  null,
  null,
  null
);
const wc = $c.exports;
const kc = {
  DEFAULT: "default",
  BONUS: "bonus"
}, Dc = {
  name: "DsToggle",
  components: { DsIcon: R },
  props: {
    value: Boolean,
    disabled: Boolean,
    color: {
      type: String,
      default: "default",
      validator(s) {
        var t;
        return Object.values(kc).includes((t = s == null ? void 0 : s.toLowerCase) == null ? void 0 : t.call(s));
      }
    }
  },
  emits: ["input"]
};
var Sc = function() {
  var t = this, e = t._self._c;
  return e("button", { staticClass: "ds-toggle", class: [`ds-toggle--color-${t.color}`, { "ds-toggle--active": t.value }], attrs: { disabled: t.disabled }, on: { mousedown: function(n) {
    return t.$emit("input", !t.value);
  } } }, [e("span", { staticClass: "ds-toggle__handle" }, [e("DsIcon", { staticClass: "ds-toggle__icon", attrs: { name: "system/check-400" } })], 1)]);
}, Tc = [], Rc = /* @__PURE__ */ d(
  Dc,
  Sc,
  Tc,
  !1,
  null,
  "df446c1a",
  null,
  null
);
const Xd = Rc.exports, tt = Math.min, E = Math.max, Lt = Math.round, Ot = Math.floor, et = (s) => ({
  x: s,
  y: s
}), Bc = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Oc = {
  start: "end",
  end: "start"
};
function se(s, t, e) {
  return E(s, tt(t, e));
}
function ft(s, t) {
  return typeof s == "function" ? s(t) : s;
}
function st(s) {
  return s.split("-")[0];
}
function pt(s) {
  return s.split("-")[1];
}
function ls(s) {
  return s === "x" ? "y" : "x";
}
function _e(s) {
  return s === "y" ? "height" : "width";
}
function Tt(s) {
  return ["top", "bottom"].includes(st(s)) ? "y" : "x";
}
function fe(s) {
  return ls(Tt(s));
}
function Ac(s, t, e) {
  e === void 0 && (e = !1);
  const n = pt(s), o = fe(s), a = _e(o);
  let r = o === "x" ? n === (e ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return t.reference[a] > t.floating[a] && (r = Ft(r)), [r, Ft(r)];
}
function Ic(s) {
  const t = Ft(s);
  return [ne(s), t, ne(t)];
}
function ne(s) {
  return s.replace(/start|end/g, (t) => Oc[t]);
}
function Pc(s, t, e) {
  const n = ["left", "right"], o = ["right", "left"], a = ["top", "bottom"], r = ["bottom", "top"];
  switch (s) {
    case "top":
    case "bottom":
      return e ? t ? o : n : t ? n : o;
    case "left":
    case "right":
      return t ? a : r;
    default:
      return [];
  }
}
function Ec(s, t, e, n) {
  const o = pt(s);
  let a = Pc(st(s), e === "start", n);
  return o && (a = a.map((r) => r + "-" + o), t && (a = a.concat(a.map(ne)))), a;
}
function Ft(s) {
  return s.replace(/left|right|bottom|top/g, (t) => Bc[t]);
}
function Lc(s) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...s
  };
}
function cs(s) {
  return typeof s != "number" ? Lc(s) : {
    top: s,
    right: s,
    bottom: s,
    left: s
  };
}
function Mt(s) {
  return {
    ...s,
    top: s.y,
    left: s.x,
    right: s.x + s.width,
    bottom: s.y + s.height
  };
}
function Le(s, t, e) {
  let {
    reference: n,
    floating: o
  } = s;
  const a = Tt(t), r = fe(t), i = _e(r), l = st(t), c = a === "y", u = n.x + n.width / 2 - o.width / 2, _ = n.y + n.height / 2 - o.height / 2, p = n[i] / 2 - o[i] / 2;
  let f;
  switch (l) {
    case "top":
      f = {
        x: u,
        y: n.y - o.height
      };
      break;
    case "bottom":
      f = {
        x: u,
        y: n.y + n.height
      };
      break;
    case "right":
      f = {
        x: n.x + n.width,
        y: _
      };
      break;
    case "left":
      f = {
        x: n.x - o.width,
        y: _
      };
      break;
    default:
      f = {
        x: n.x,
        y: n.y
      };
  }
  switch (pt(t)) {
    case "start":
      f[r] -= p * (e && c ? -1 : 1);
      break;
    case "end":
      f[r] += p * (e && c ? -1 : 1);
      break;
  }
  return f;
}
const Fc = async (s, t, e) => {
  const {
    placement: n = "bottom",
    strategy: o = "absolute",
    middleware: a = [],
    platform: r
  } = e, i = a.filter(Boolean), l = await (r.isRTL == null ? void 0 : r.isRTL(t));
  let c = await r.getElementRects({
    reference: s,
    floating: t,
    strategy: o
  }), {
    x: u,
    y: _
  } = Le(c, n, l), p = n, f = {}, v = 0;
  for (let y = 0; y < i.length; y++) {
    const {
      name: g,
      fn: m
    } = i[y], {
      x: C,
      y: b,
      data: w,
      reset: D
    } = await m({
      x: u,
      y: _,
      initialPlacement: n,
      placement: p,
      strategy: o,
      middlewareData: f,
      rects: c,
      platform: r,
      elements: {
        reference: s,
        floating: t
      }
    });
    if (u = C ?? u, _ = b ?? _, f = {
      ...f,
      [g]: {
        ...f[g],
        ...w
      }
    }, D && v <= 50) {
      v++, typeof D == "object" && (D.placement && (p = D.placement), D.rects && (c = D.rects === !0 ? await r.getElementRects({
        reference: s,
        floating: t,
        strategy: o
      }) : D.rects), {
        x: u,
        y: _
      } = Le(c, p, l)), y = -1;
      continue;
    }
  }
  return {
    x: u,
    y: _,
    placement: p,
    strategy: o,
    middlewareData: f
  };
};
async function pe(s, t) {
  var e;
  t === void 0 && (t = {});
  const {
    x: n,
    y: o,
    platform: a,
    rects: r,
    elements: i,
    strategy: l
  } = s, {
    boundary: c = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: _ = "floating",
    altBoundary: p = !1,
    padding: f = 0
  } = ft(t, s), v = cs(f), g = i[p ? _ === "floating" ? "reference" : "floating" : _], m = Mt(await a.getClippingRect({
    element: (e = await (a.isElement == null ? void 0 : a.isElement(g))) == null || e ? g : g.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(i.floating)),
    boundary: c,
    rootBoundary: u,
    strategy: l
  })), C = _ === "floating" ? {
    ...r.floating,
    x: n,
    y: o
  } : r.reference, b = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(i.floating)), w = await (a.isElement == null ? void 0 : a.isElement(b)) ? await (a.getScale == null ? void 0 : a.getScale(b)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, D = Mt(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect: C,
    offsetParent: b,
    strategy: l
  }) : C);
  return {
    top: (m.top - D.top + v.top) / w.y,
    bottom: (D.bottom - m.bottom + v.bottom) / w.y,
    left: (m.left - D.left + v.left) / w.x,
    right: (D.right - m.right + v.right) / w.x
  };
}
const Mc = (s) => ({
  name: "arrow",
  options: s,
  async fn(t) {
    const {
      x: e,
      y: n,
      placement: o,
      rects: a,
      platform: r,
      elements: i,
      middlewareData: l
    } = t, {
      element: c,
      padding: u = 0
    } = ft(s, t) || {};
    if (c == null)
      return {};
    const _ = cs(u), p = {
      x: e,
      y: n
    }, f = fe(o), v = _e(f), y = await r.getDimensions(c), g = f === "y", m = g ? "top" : "left", C = g ? "bottom" : "right", b = g ? "clientHeight" : "clientWidth", w = a.reference[v] + a.reference[f] - p[f] - a.floating[v], D = p[f] - a.reference[f], T = await (r.getOffsetParent == null ? void 0 : r.getOffsetParent(c));
    let $ = T ? T[b] : 0;
    (!$ || !await (r.isElement == null ? void 0 : r.isElement(T))) && ($ = i.floating[b] || a.floating[v]);
    const A = w / 2 - D / 2, H = $ / 2 - y[v] / 2 - 1, vt = tt(_[m], H), mt = tt(_[C], H), M = vt, ht = $ - y[v] - mt, I = $ / 2 - y[v] / 2 + A, N = se(M, I, ht), V = !l.arrow && pt(o) != null && I != N && a.reference[v] / 2 - (I < M ? vt : mt) - y[v] / 2 < 0, U = V ? I < M ? I - M : I - ht : 0;
    return {
      [f]: p[f] + U,
      data: {
        [f]: N,
        centerOffset: I - N - U,
        ...V && {
          alignmentOffset: U
        }
      },
      reset: V
    };
  }
}), zc = function(s) {
  return s === void 0 && (s = {}), {
    name: "flip",
    options: s,
    async fn(t) {
      var e, n;
      const {
        placement: o,
        middlewareData: a,
        rects: r,
        initialPlacement: i,
        platform: l,
        elements: c
      } = t, {
        mainAxis: u = !0,
        crossAxis: _ = !0,
        fallbackPlacements: p,
        fallbackStrategy: f = "bestFit",
        fallbackAxisSideDirection: v = "none",
        flipAlignment: y = !0,
        ...g
      } = ft(s, t);
      if ((e = a.arrow) != null && e.alignmentOffset)
        return {};
      const m = st(o), C = st(i) === i, b = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), w = p || (C || !y ? [Ft(i)] : Ic(i));
      !p && v !== "none" && w.push(...Ec(i, y, v, b));
      const D = [i, ...w], T = await pe(t, g), $ = [];
      let A = ((n = a.flip) == null ? void 0 : n.overflows) || [];
      if (u && $.push(T[m]), _) {
        const M = Ac(o, r, b);
        $.push(T[M[0]], T[M[1]]);
      }
      if (A = [...A, {
        placement: o,
        overflows: $
      }], !$.every((M) => M <= 0)) {
        var H, vt;
        const M = (((H = a.flip) == null ? void 0 : H.index) || 0) + 1, ht = D[M];
        if (ht)
          return {
            data: {
              index: M,
              overflows: A
            },
            reset: {
              placement: ht
            }
          };
        let I = (vt = A.filter((N) => N.overflows[0] <= 0).sort((N, V) => N.overflows[1] - V.overflows[1])[0]) == null ? void 0 : vt.placement;
        if (!I)
          switch (f) {
            case "bestFit": {
              var mt;
              const N = (mt = A.map((V) => [V.placement, V.overflows.filter((U) => U > 0).reduce((U, gs) => U + gs, 0)]).sort((V, U) => V[1] - U[1])[0]) == null ? void 0 : mt[0];
              N && (I = N);
              break;
            }
            case "initialPlacement":
              I = i;
              break;
          }
        if (o !== I)
          return {
            reset: {
              placement: I
            }
          };
      }
      return {};
    }
  };
};
async function Hc(s, t) {
  const {
    placement: e,
    platform: n,
    elements: o
  } = s, a = await (n.isRTL == null ? void 0 : n.isRTL(o.floating)), r = st(e), i = pt(e), l = Tt(e) === "y", c = ["left", "top"].includes(r) ? -1 : 1, u = a && l ? -1 : 1, _ = ft(t, s);
  let {
    mainAxis: p,
    crossAxis: f,
    alignmentAxis: v
  } = typeof _ == "number" ? {
    mainAxis: _,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ..._
  };
  return i && typeof v == "number" && (f = i === "end" ? v * -1 : v), l ? {
    x: f * u,
    y: p * c
  } : {
    x: p * c,
    y: f * u
  };
}
const Nc = function(s) {
  return s === void 0 && (s = 0), {
    name: "offset",
    options: s,
    async fn(t) {
      const {
        x: e,
        y: n
      } = t, o = await Hc(t, s);
      return {
        x: e + o.x,
        y: n + o.y,
        data: o
      };
    }
  };
}, Vc = function(s) {
  return s === void 0 && (s = {}), {
    name: "shift",
    options: s,
    async fn(t) {
      const {
        x: e,
        y: n,
        placement: o
      } = t, {
        mainAxis: a = !0,
        crossAxis: r = !1,
        limiter: i = {
          fn: (g) => {
            let {
              x: m,
              y: C
            } = g;
            return {
              x: m,
              y: C
            };
          }
        },
        ...l
      } = ft(s, t), c = {
        x: e,
        y: n
      }, u = await pe(t, l), _ = Tt(st(o)), p = ls(_);
      let f = c[p], v = c[_];
      if (a) {
        const g = p === "y" ? "top" : "left", m = p === "y" ? "bottom" : "right", C = f + u[g], b = f - u[m];
        f = se(C, f, b);
      }
      if (r) {
        const g = _ === "y" ? "top" : "left", m = _ === "y" ? "bottom" : "right", C = v + u[g], b = v - u[m];
        v = se(C, v, b);
      }
      const y = i.fn({
        ...t,
        [p]: f,
        [_]: v
      });
      return {
        ...y,
        data: {
          x: y.x - e,
          y: y.y - n
        }
      };
    }
  };
}, Wc = function(s) {
  return s === void 0 && (s = {}), {
    name: "size",
    options: s,
    async fn(t) {
      const {
        placement: e,
        rects: n,
        platform: o,
        elements: a
      } = t, {
        apply: r = () => {
        },
        ...i
      } = ft(s, t), l = await pe(t, i), c = st(e), u = pt(e), _ = Tt(e) === "y", {
        width: p,
        height: f
      } = n.floating;
      let v, y;
      c === "top" || c === "bottom" ? (v = c, y = u === (await (o.isRTL == null ? void 0 : o.isRTL(a.floating)) ? "start" : "end") ? "left" : "right") : (y = c, v = u === "end" ? "top" : "bottom");
      const g = f - l[v], m = p - l[y], C = !t.middlewareData.shift;
      let b = g, w = m;
      if (_) {
        const T = p - l.left - l.right;
        w = u || C ? tt(m, T) : T;
      } else {
        const T = f - l.top - l.bottom;
        b = u || C ? tt(g, T) : T;
      }
      if (C && !u) {
        const T = E(l.left, 0), $ = E(l.right, 0), A = E(l.top, 0), H = E(l.bottom, 0);
        _ ? w = p - 2 * (T !== 0 || $ !== 0 ? T + $ : E(l.left, l.right)) : b = f - 2 * (A !== 0 || H !== 0 ? A + H : E(l.top, l.bottom));
      }
      await r({
        ...t,
        availableWidth: w,
        availableHeight: b
      });
      const D = await o.getDimensions(a.floating);
      return p !== D.width || f !== D.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function nt(s) {
  return us(s) ? (s.nodeName || "").toLowerCase() : "#document";
}
function L(s) {
  var t;
  return (s == null || (t = s.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function G(s) {
  var t;
  return (t = (us(s) ? s.ownerDocument : s.document) || window.document) == null ? void 0 : t.documentElement;
}
function us(s) {
  return s instanceof Node || s instanceof L(s).Node;
}
function X(s) {
  return s instanceof Element || s instanceof L(s).Element;
}
function W(s) {
  return s instanceof HTMLElement || s instanceof L(s).HTMLElement;
}
function Fe(s) {
  return typeof ShadowRoot > "u" ? !1 : s instanceof ShadowRoot || s instanceof L(s).ShadowRoot;
}
function Rt(s) {
  const {
    overflow: t,
    overflowX: e,
    overflowY: n,
    display: o
  } = z(s);
  return /auto|scroll|overlay|hidden|clip/.test(t + n + e) && !["inline", "contents"].includes(o);
}
function jc(s) {
  return ["table", "td", "th"].includes(nt(s));
}
function ve(s) {
  const t = me(), e = z(s);
  return e.transform !== "none" || e.perspective !== "none" || (e.containerType ? e.containerType !== "normal" : !1) || !t && (e.backdropFilter ? e.backdropFilter !== "none" : !1) || !t && (e.filter ? e.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((n) => (e.willChange || "").includes(n)) || ["paint", "layout", "strict", "content"].some((n) => (e.contain || "").includes(n));
}
function Uc(s) {
  let t = _t(s);
  for (; W(t) && !Yt(t); ) {
    if (ve(t))
      return t;
    t = _t(t);
  }
  return null;
}
function me() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Yt(s) {
  return ["html", "body", "#document"].includes(nt(s));
}
function z(s) {
  return L(s).getComputedStyle(s);
}
function qt(s) {
  return X(s) ? {
    scrollLeft: s.scrollLeft,
    scrollTop: s.scrollTop
  } : {
    scrollLeft: s.pageXOffset,
    scrollTop: s.pageYOffset
  };
}
function _t(s) {
  if (nt(s) === "html")
    return s;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    s.assignedSlot || // DOM Element detected.
    s.parentNode || // ShadowRoot detected.
    Fe(s) && s.host || // Fallback.
    G(s)
  );
  return Fe(t) ? t.host : t;
}
function ds(s) {
  const t = _t(s);
  return Yt(t) ? s.ownerDocument ? s.ownerDocument.body : s.body : W(t) && Rt(t) ? t : ds(t);
}
function xt(s, t, e) {
  var n;
  t === void 0 && (t = []), e === void 0 && (e = !0);
  const o = ds(s), a = o === ((n = s.ownerDocument) == null ? void 0 : n.body), r = L(o);
  return a ? t.concat(r, r.visualViewport || [], Rt(o) ? o : [], r.frameElement && e ? xt(r.frameElement) : []) : t.concat(o, xt(o, [], e));
}
function _s(s) {
  const t = z(s);
  let e = parseFloat(t.width) || 0, n = parseFloat(t.height) || 0;
  const o = W(s), a = o ? s.offsetWidth : e, r = o ? s.offsetHeight : n, i = Lt(e) !== a || Lt(n) !== r;
  return i && (e = a, n = r), {
    width: e,
    height: n,
    $: i
  };
}
function he(s) {
  return X(s) ? s : s.contextElement;
}
function dt(s) {
  const t = he(s);
  if (!W(t))
    return et(1);
  const e = t.getBoundingClientRect(), {
    width: n,
    height: o,
    $: a
  } = _s(t);
  let r = (a ? Lt(e.width) : e.width) / n, i = (a ? Lt(e.height) : e.height) / o;
  return (!r || !Number.isFinite(r)) && (r = 1), (!i || !Number.isFinite(i)) && (i = 1), {
    x: r,
    y: i
  };
}
const Yc = /* @__PURE__ */ et(0);
function fs(s) {
  const t = L(s);
  return !me() || !t.visualViewport ? Yc : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function qc(s, t, e) {
  return t === void 0 && (t = !1), !e || t && e !== L(s) ? !1 : t;
}
function it(s, t, e, n) {
  t === void 0 && (t = !1), e === void 0 && (e = !1);
  const o = s.getBoundingClientRect(), a = he(s);
  let r = et(1);
  t && (n ? X(n) && (r = dt(n)) : r = dt(s));
  const i = qc(a, e, n) ? fs(a) : et(0);
  let l = (o.left + i.x) / r.x, c = (o.top + i.y) / r.y, u = o.width / r.x, _ = o.height / r.y;
  if (a) {
    const p = L(a), f = n && X(n) ? L(n) : n;
    let v = p.frameElement;
    for (; v && n && f !== p; ) {
      const y = dt(v), g = v.getBoundingClientRect(), m = z(v), C = g.left + (v.clientLeft + parseFloat(m.paddingLeft)) * y.x, b = g.top + (v.clientTop + parseFloat(m.paddingTop)) * y.y;
      l *= y.x, c *= y.y, u *= y.x, _ *= y.y, l += C, c += b, v = L(v).frameElement;
    }
  }
  return Mt({
    width: u,
    height: _,
    x: l,
    y: c
  });
}
function Zc(s) {
  let {
    rect: t,
    offsetParent: e,
    strategy: n
  } = s;
  const o = W(e), a = G(e);
  if (e === a)
    return t;
  let r = {
    scrollLeft: 0,
    scrollTop: 0
  }, i = et(1);
  const l = et(0);
  if ((o || !o && n !== "fixed") && ((nt(e) !== "body" || Rt(a)) && (r = qt(e)), W(e))) {
    const c = it(e);
    i = dt(e), l.x = c.x + e.clientLeft, l.y = c.y + e.clientTop;
  }
  return {
    width: t.width * i.x,
    height: t.height * i.y,
    x: t.x * i.x - r.scrollLeft * i.x + l.x,
    y: t.y * i.y - r.scrollTop * i.y + l.y
  };
}
function Xc(s) {
  return Array.from(s.getClientRects());
}
function ps(s) {
  return it(G(s)).left + qt(s).scrollLeft;
}
function Gc(s) {
  const t = G(s), e = qt(s), n = s.ownerDocument.body, o = E(t.scrollWidth, t.clientWidth, n.scrollWidth, n.clientWidth), a = E(t.scrollHeight, t.clientHeight, n.scrollHeight, n.clientHeight);
  let r = -e.scrollLeft + ps(s);
  const i = -e.scrollTop;
  return z(n).direction === "rtl" && (r += E(t.clientWidth, n.clientWidth) - o), {
    width: o,
    height: a,
    x: r,
    y: i
  };
}
function Kc(s, t) {
  const e = L(s), n = G(s), o = e.visualViewport;
  let a = n.clientWidth, r = n.clientHeight, i = 0, l = 0;
  if (o) {
    a = o.width, r = o.height;
    const c = me();
    (!c || c && t === "fixed") && (i = o.offsetLeft, l = o.offsetTop);
  }
  return {
    width: a,
    height: r,
    x: i,
    y: l
  };
}
function Jc(s, t) {
  const e = it(s, !0, t === "fixed"), n = e.top + s.clientTop, o = e.left + s.clientLeft, a = W(s) ? dt(s) : et(1), r = s.clientWidth * a.x, i = s.clientHeight * a.y, l = o * a.x, c = n * a.y;
  return {
    width: r,
    height: i,
    x: l,
    y: c
  };
}
function Me(s, t, e) {
  let n;
  if (t === "viewport")
    n = Kc(s, e);
  else if (t === "document")
    n = Gc(G(s));
  else if (X(t))
    n = Jc(t, e);
  else {
    const o = fs(s);
    n = {
      ...t,
      x: t.x - o.x,
      y: t.y - o.y
    };
  }
  return Mt(n);
}
function vs(s, t) {
  const e = _t(s);
  return e === t || !X(e) || Yt(e) ? !1 : z(e).position === "fixed" || vs(e, t);
}
function Qc(s, t) {
  const e = t.get(s);
  if (e)
    return e;
  let n = xt(s, [], !1).filter((i) => X(i) && nt(i) !== "body"), o = null;
  const a = z(s).position === "fixed";
  let r = a ? _t(s) : s;
  for (; X(r) && !Yt(r); ) {
    const i = z(r), l = ve(r);
    !l && i.position === "fixed" && (o = null), (a ? !l && !o : !l && i.position === "static" && !!o && ["absolute", "fixed"].includes(o.position) || Rt(r) && !l && vs(s, r)) ? n = n.filter((u) => u !== r) : o = i, r = _t(r);
  }
  return t.set(s, n), n;
}
function tu(s) {
  let {
    element: t,
    boundary: e,
    rootBoundary: n,
    strategy: o
  } = s;
  const r = [...e === "clippingAncestors" ? Qc(t, this._c) : [].concat(e), n], i = r[0], l = r.reduce((c, u) => {
    const _ = Me(t, u, o);
    return c.top = E(_.top, c.top), c.right = tt(_.right, c.right), c.bottom = tt(_.bottom, c.bottom), c.left = E(_.left, c.left), c;
  }, Me(t, i, o));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function eu(s) {
  return _s(s);
}
function su(s, t, e) {
  const n = W(t), o = G(t), a = e === "fixed", r = it(s, !0, a, t);
  let i = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = et(0);
  if (n || !n && !a)
    if ((nt(t) !== "body" || Rt(o)) && (i = qt(t)), n) {
      const c = it(t, !0, a, t);
      l.x = c.x + t.clientLeft, l.y = c.y + t.clientTop;
    } else
      o && (l.x = ps(o));
  return {
    x: r.left + i.scrollLeft - l.x,
    y: r.top + i.scrollTop - l.y,
    width: r.width,
    height: r.height
  };
}
function ze(s, t) {
  return !W(s) || z(s).position === "fixed" ? null : t ? t(s) : s.offsetParent;
}
function ms(s, t) {
  const e = L(s);
  if (!W(s))
    return e;
  let n = ze(s, t);
  for (; n && jc(n) && z(n).position === "static"; )
    n = ze(n, t);
  return n && (nt(n) === "html" || nt(n) === "body" && z(n).position === "static" && !ve(n)) ? e : n || Uc(s) || e;
}
const nu = async function(s) {
  let {
    reference: t,
    floating: e,
    strategy: n
  } = s;
  const o = this.getOffsetParent || ms, a = this.getDimensions;
  return {
    reference: su(t, await o(e), n),
    floating: {
      x: 0,
      y: 0,
      ...await a(e)
    }
  };
};
function ou(s) {
  return z(s).direction === "rtl";
}
const ru = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Zc,
  getDocumentElement: G,
  getClippingRect: tu,
  getOffsetParent: ms,
  getElementRects: nu,
  getClientRects: Xc,
  getDimensions: eu,
  getScale: dt,
  isElement: X,
  isRTL: ou
};
function au(s, t) {
  let e = null, n;
  const o = G(s);
  function a() {
    clearTimeout(n), e && e.disconnect(), e = null;
  }
  function r(i, l) {
    i === void 0 && (i = !1), l === void 0 && (l = 1), a();
    const {
      left: c,
      top: u,
      width: _,
      height: p
    } = s.getBoundingClientRect();
    if (i || t(), !_ || !p)
      return;
    const f = Ot(u), v = Ot(o.clientWidth - (c + _)), y = Ot(o.clientHeight - (u + p)), g = Ot(c), C = {
      rootMargin: -f + "px " + -v + "px " + -y + "px " + -g + "px",
      threshold: E(0, tt(1, l)) || 1
    };
    let b = !0;
    function w(D) {
      const T = D[0].intersectionRatio;
      if (T !== l) {
        if (!b)
          return r();
        T ? r(!1, T) : n = setTimeout(() => {
          r(!1, 1e-7);
        }, 100);
      }
      b = !1;
    }
    try {
      e = new IntersectionObserver(w, {
        ...C,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      e = new IntersectionObserver(w, C);
    }
    e.observe(s);
  }
  return r(!0), a;
}
function iu(s, t, e, n) {
  n === void 0 && (n = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: a = !0,
    elementResize: r = typeof ResizeObserver == "function",
    layoutShift: i = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = n, c = he(s), u = o || a ? [...c ? xt(c) : [], ...xt(t)] : [];
  u.forEach((m) => {
    o && m.addEventListener("scroll", e, {
      passive: !0
    }), a && m.addEventListener("resize", e);
  });
  const _ = c && i ? au(c, e) : null;
  let p = -1, f = null;
  r && (f = new ResizeObserver((m) => {
    let [C] = m;
    C && C.target === c && f && (f.unobserve(t), cancelAnimationFrame(p), p = requestAnimationFrame(() => {
      f && f.observe(t);
    })), e();
  }), c && !l && f.observe(c), f.observe(t));
  let v, y = l ? it(s) : null;
  l && g();
  function g() {
    const m = it(s);
    y && (m.x !== y.x || m.y !== y.y || m.width !== y.width || m.height !== y.height) && e(), y = m, v = requestAnimationFrame(g);
  }
  return e(), () => {
    u.forEach((m) => {
      o && m.removeEventListener("scroll", e), a && m.removeEventListener("resize", e);
    }), _ && _(), f && f.disconnect(), f = null, l && cancelAnimationFrame(v);
  };
}
const lu = (s, t, e) => {
  const n = /* @__PURE__ */ new Map(), o = {
    platform: ru,
    ...e
  }, a = {
    ...o.platform,
    _c: n
  };
  return Fc(s, t, {
    ...o,
    platform: a
  });
};
bs.util.warn;
function oe(s) {
  var t;
  return (t = s == null ? void 0 : s.$el) != null ? t : s;
}
function cu(s) {
  return {
    name: "arrow",
    options: s,
    fn(t) {
      const e = oe(ut(s.element));
      return e == null ? {} : Mc({
        element: e,
        padding: s.padding
      }).fn(t);
    }
  };
}
function hs(s) {
  return typeof window > "u" ? 1 : (s.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function He(s, t) {
  const e = hs(s);
  return Math.round(t * e) / e;
}
function uu(s, t, e) {
  e === void 0 && (e = {});
  const n = e.whileElementsMounted, o = x(() => {
    var $;
    return ($ = ut(e.open)) != null ? $ : !0;
  }), a = x(() => ut(e.middleware)), r = x(() => {
    var $;
    return ($ = ut(e.placement)) != null ? $ : "bottom";
  }), i = x(() => {
    var $;
    return ($ = ut(e.strategy)) != null ? $ : "absolute";
  }), l = x(() => {
    var $;
    return ($ = ut(e.transform)) != null ? $ : !0;
  }), c = x(() => oe(s.value)), u = x(() => oe(t.value)), _ = h(0), p = h(0), f = h(i.value), v = h(r.value), y = We({}), g = h(!1), m = x(() => {
    const $ = {
      position: f.value,
      left: "0",
      top: "0"
    };
    if (!u.value)
      return $;
    const A = He(u.value, _.value), H = He(u.value, p.value);
    return l.value ? {
      ...$,
      transform: "translate(" + A + "px, " + H + "px)",
      ...hs(u.value) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: f.value,
      left: A + "px",
      top: H + "px"
    };
  });
  let C;
  function b() {
    c.value == null || u.value == null || lu(c.value, u.value, {
      middleware: a.value,
      placement: r.value,
      strategy: i.value
    }).then(($) => {
      _.value = $.x, p.value = $.y, f.value = $.strategy, v.value = $.placement, y.value = $.middlewareData, g.value = !0;
    });
  }
  function w() {
    typeof C == "function" && (C(), C = void 0);
  }
  function D() {
    if (w(), n === void 0) {
      b();
      return;
    }
    if (c.value != null && u.value != null) {
      C = n(c.value, u.value, b);
      return;
    }
  }
  function T() {
    o.value || (g.value = !1);
  }
  return O([a, r, i], b, {
    flush: "sync"
  }), O([c, u], D, {
    flush: "sync"
  }), O(o, T, {
    flush: "sync"
  }), $s() && ws(w), {
    x: ct(_),
    y: ct(p),
    strategy: ct(f),
    placement: ct(v),
    middlewareData: ct(y),
    isPositioned: ct(g),
    floatingStyles: m,
    update: b
  };
}
const Ne = 280, du = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, _u = {
  name: "DsTooltip",
  components: {
    DsFadeTransition: ie
  },
  props: {
    value: Boolean,
    placement: {
      type: String,
      default: "bottom"
    },
    strategy: {
      type: String,
      default: "absolute"
    },
    offset: {
      type: Number,
      default: 8
    },
    shiftPadding: {
      type: Number,
      default: 16
    }
  },
  emits: ["input"],
  setup(s) {
    const { placement: t, strategy: e } = ks(s), n = h(null), o = h(null), a = h(null), r = h(0), i = h([
      Nc(s.offset),
      zc(),
      Vc({ padding: s.shiftPadding }),
      cu({ element: a }),
      Wc({
        apply({ availableWidth: f }) {
          r.value = f;
        }
      })
    ]), {
      floatingStyles: l,
      middlewareData: c,
      placement: u
    } = uu(n, o, {
      placement: t,
      strategy: e,
      middleware: i,
      whileElementsMounted: iu
    }), _ = x(() => {
      const f = s.shiftPadding * 2;
      let v = Ne;
      return r.value > f && (v = Math.min(r.value - f, Ne)), {
        ...l.value,
        width: `${v}px`
      };
    }), p = x(() => {
      const f = c.value.arrow, v = du[u.value.split("-")[0]];
      return {
        left: typeof (f == null ? void 0 : f.x) == "number" ? `${f.x}px` : "",
        top: typeof (f == null ? void 0 : f.y) == "number" ? `${f.y}px` : "",
        [v]: "-4.69px"
      };
    });
    return {
      reference: n,
      floating: o,
      floatingArrow: a,
      tooltipStyles: _,
      arrowStyles: p
    };
  }
};
var fu = function() {
  var t = this, e = t._self._c;
  return e("div", { ref: "reference", staticClass: "ds-tooltip__reference" }, [t._t("reference"), e("DsFadeTransition", [t.value ? e("div", { ref: "floating", staticClass: "ds-tooltip__floating", style: t.tooltipStyles }, [t.$slots.title ? e("div", { staticClass: "ds-tooltip__title title-500-accent" }, [t._t("title")], 2) : t._e(), t.$slots.description ? e("div", { staticClass: "ds-tooltip__description body-400" }, [t._t("description")], 2) : t._e(), t.$slots.button ? e("div", { staticClass: "ds-tooltip__button" }, [t._t("button")], 2) : t._e(), e("div", { ref: "floatingArrow", staticClass: "ds-tooltip__arrow", style: t.arrowStyles })]) : t._e()])], 2);
}, pu = [], vu = /* @__PURE__ */ d(
  _u,
  fu,
  pu,
  !1,
  null,
  "bb4c3a89",
  null,
  null
);
const Gd = vu.exports;
const mu = {
  __name: "DsSnackbar",
  props: {
    icon: Boolean,
    visible: Boolean
  },
  emits: ["update:visible"],
  setup(s, { emit: t }) {
    const e = s, n = 2e3;
    let o = null;
    return O(
      () => e.visible,
      () => {
        o && (clearTimeout(o), o = null), o = setTimeout(() => {
          t("update:visible", !1);
        }, n);
      }
    ), { __sfc: !0, SHOW_TIMEOUT: n, emit: t, props: e, timeout: o, DsContainer: S, DsIcon: R, DsLinkDefault: wi, DsFadeTransition: ie };
  }
};
var hu = function() {
  var t = this, e = t._self._c, n = t._self._setupProxy;
  return e(n.DsFadeTransition, [t.visible ? e(n.DsContainer, { staticClass: "ds-snackbar py-400" }, [e("div", { staticClass: "ds-snackbar__wrapper neutral-back-dark border-radius-400 p-500" }, [t.icon && !t.$slots.link ? e("div", { staticClass: "ds-snackbar__icon" }, [e(n.DsIcon, { attrs: { name: "check-circle-500", color: "icon-inverse" } })], 1) : t._e(), e("div", { staticClass: "ds-snackbar__main" }, [e("div", { staticClass: "body-500-soft" }, [t._t("default")], 2), t.$slots.link ? e(n.DsLinkDefault, { staticClass: "ds-snackbar__link" }, [t._t("link")], 2) : t.$slots.caption ? e("div", { staticClass: "ds-snackbar__caption caption-600" }, [t._t("caption")], 2) : t._e()], 1), t.$slots.right ? e("div", { staticClass: "ds-snackbar__right" }, [t._t("right")], 2) : t._e()])]) : t._e()], 1);
}, gu = [], bu = /* @__PURE__ */ d(
  mu,
  hu,
  gu,
  !1,
  null,
  null,
  null,
  null
);
const Kd = bu.exports, yu = /* @__PURE__ */ k({
  __name: "DsUnavailable",
  props: {
    illustration: null,
    title: null,
    description: null,
    buttonLabel: null,
    outline: { type: Boolean }
  },
  emits: ["action"],
  setup(s, { emit: t }) {
    return { __sfc: !0, emit: t, onButtonClick: () => {
      t("action");
    }, DsIllustration: de, DsButton: So };
  }
});
var xu = function() {
  var t = this, e = t._self._c, n = t._self._setupProxy;
  return e("div", { staticClass: "ds-unavailable" }, [e(n.DsIllustration, { attrs: { name: t.illustration, type: "narrow" } }), e("div", { staticClass: "ds-unavailable__block" }, [e("h4", { staticClass: "ds-unavailable__block__text title-600-heavy", domProps: { innerHTML: t._s(t.title) } }), e("span", { staticClass: "ds-unavailable__block__text--description body-500", domProps: { innerHTML: t._s(t.description) } })]), t.buttonLabel ? e(n.DsButton, { staticClass: "ds-unavailbale__btn", attrs: { size: "m", type: t.outline ? "outline" : "primary" }, on: { click: n.onButtonClick } }, [t._v(" " + t._s(t.buttonLabel) + " ")]) : t._e()], 1);
}, Cu = [], $u = /* @__PURE__ */ d(
  yu,
  xu,
  Cu,
  !1,
  null,
  "9d19ce62",
  null,
  null
);
const Jd = $u.exports, wu = /* @__PURE__ */ k({
  __name: "DsModal",
  props: {
    title: { default: "" },
    hide: { type: Boolean, default: !1 },
    value: { type: Boolean, default: !1 }
  },
  emits: ["input"],
  setup(s, { emit: t }) {
    const e = s, n = h(!1);
    O(
      () => e.value,
      (a) => {
        a ? (n.value = a, document.body.style.overflow = "hidden") : (document.body.style.overflow = "", setTimeout(() => {
          n.value = a;
        }, 200));
      }
    );
    function o() {
      t("input", !1);
    }
    return { __sfc: !0, emit: t, props: e, isVisible: n, closeModal: o, DsLayout: fi, DsNavBar: Ii, DsNavButton: Mi, DsIcon: R, DsPortal: ce };
  }
});
var ku = function() {
  var t = this, e = t._self._c, n = t._self._setupProxy;
  return e(n.DsPortal, { attrs: { to: "body" } }, [e("div", { staticClass: "ds-modal", class: {
    "ds-modal--visible": t.value
  } }, [e(n.DsLayout, { directives: [{ name: "show", rawName: "v-show", value: !t.hide || n.isVisible, expression: "!hide || isVisible" }], scopedSlots: t._u([{ key: "header", fn: function() {
    return [n.isVisible ? e(n.DsNavBar, { scopedSlots: t._u([{ key: "left", fn: function() {
      return [t._t("navbarLeft")];
    }, proxy: !0 }, { key: "right", fn: function() {
      return [t._t("navbarRight", function() {
        return [e(n.DsNavButton, { on: { click: n.closeModal } }, [e(n.DsIcon, { attrs: { name: "close-500", color: "icon-accent" } })], 1)];
      })];
    }, proxy: !0 }], null, !0) }, [t.title ? [t._v(" " + t._s(t.title) + " ")] : t._e()], 2) : t._e()];
  }, proxy: !0 }]) }, [t._t("default")], 2)], 1)]);
}, Du = [], Su = /* @__PURE__ */ d(
  wu,
  ku,
  Du,
  !1,
  null,
  null,
  null,
  null
);
const Qd = Su.exports, Tu = /* @__PURE__ */ k({
  __name: "DsSkeletonTitle",
  props: {
    visible: { type: Boolean }
  },
  setup(s) {
    return { __sfc: !0, props: s, DsTitle: wc };
  }
});
var Ru = function() {
  var t = this, e = t._self._c, n = t._self._setupProxy;
  return n.props.visible ? e(n.DsTitle, { attrs: { size: "h4" } }, [e("div", { staticClass: "title" }, [e("div", { staticClass: "skeleton" })])]) : t._e();
}, Bu = [], Ou = /* @__PURE__ */ d(
  Tu,
  Ru,
  Bu,
  !1,
  null,
  "4b084ee4",
  null,
  null
);
const t_ = Ou.exports, Au = /* @__PURE__ */ k({
  __name: "DsSkeletonText",
  props: {
    size: { default: "XL" },
    visible: { type: Boolean }
  },
  setup(s) {
    return { __sfc: !0 };
  }
});
var Iu = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, t.visible ? e("div", { staticClass: "title", class: ` title-${t.size}` }, [e("div", { staticClass: "skeleton" })]) : t._e();
}, Pu = [], Eu = /* @__PURE__ */ d(
  Au,
  Iu,
  Pu,
  !1,
  null,
  "1df7da18",
  null,
  null
);
const e_ = Eu.exports, Lu = /* @__PURE__ */ k({
  __name: "DsSkeletonCell",
  props: {
    visible: { type: Boolean }
  },
  setup(s) {
    return { __sfc: !0, props: s, DsCell: Qe };
  }
});
var Fu = function() {
  var t = this, e = t._self._c, n = t._self._setupProxy;
  return n.props.visible ? e(n.DsCell, { scopedSlots: t._u([{ key: "left", fn: function() {
    return [e("div", { staticClass: "avatar" }, [e("div", { staticClass: "skeleton" })])];
  }, proxy: !0 }], null, !1, 3903085844) }, [e("div", { staticClass: "content" }, [e("div", { staticClass: "skeleton" })])]) : t._e();
}, Mu = [], zu = /* @__PURE__ */ d(
  Lu,
  Fu,
  Mu,
  !1,
  null,
  "9f80c446",
  null,
  null
);
const s_ = zu.exports, Hu = /* @__PURE__ */ k({
  __name: "DsCarousel",
  props: {
    gap: { default: "400" }
  },
  setup(s) {
    return { __sfc: !0, DsContainer: S };
  }
});
var Nu = function() {
  var t = this, e = t._self._c, n = t._self._setupProxy;
  return e(n.DsContainer, { staticClass: "ds-carousel", style: { gap: `var(--spacing-${t.gap})` } }, [t._t("default")], 2);
}, Vu = [], Wu = /* @__PURE__ */ d(
  Hu,
  Nu,
  Vu,
  !1,
  null,
  null,
  null,
  null
);
const n_ = Wu.exports, ju = /* @__PURE__ */ k({
  __name: "DsPullRefresh",
  props: {
    color: { default: "icon-light" },
    delay: { default: 500 }
  },
  emits: ["refresh"],
  setup(s, { emit: t }) {
    const e = s, n = h(!1), o = h(0), a = h(null);
    let r = !1, i = 0, l = 0, c = 0, u = 0, _ = null;
    function p(b) {
      b.preventDefault();
    }
    function f(b) {
      addEventListener("touchmove", p, { passive: !1 }), i = b.touches[0].clientY, l = b.touches[0].clientY, c = b.touches[0].clientX, u = b.touches[0].clientX;
    }
    function v(b) {
      if (!n.value && !r) {
        const T = b.target;
        _ = g(T), r = !!_ && _.scrollTop > 0;
      }
      if (n.value = !0, r) {
        b.stopPropagation();
        return;
      }
      l = b.touches[0].clientY, u = b.touches[0].clientX;
      const w = l - i, D = u - c;
      if (Math.abs(D) > w || c < 50) {
        b.stopPropagation();
        return;
      }
      if (!(w < 0)) {
        if (_ && _.scrollTop > 0) {
          r = !0;
          return;
        }
        r || (o.value = w > 50 ? 45 + Math.pow(w, 0.6) : w);
      }
    }
    function y() {
      removeEventListener("touchmove", p), r = !0, n.value = !1, m();
    }
    function g(b) {
      return b === null ? null : b.scrollHeight > b.clientHeight ? b : g(b.parentNode);
    }
    function m() {
      kt(() => {
        o.value < 40 ? C() : (C(40), setTimeout(() => {
          t("refresh", C);
        }, e.delay));
      });
    }
    function C(b) {
      o.value = b || 0, b || (r = !1);
    }
    return { __sfc: !0, isOnTouch: n, touchOffsetY: o, bodyRef: a, emit: t, props: e, isTouchBlocked: r, startTouchPositionY: i, currentTouchPositionY: l, startTouchPositionX: c, currentTouchPositionX: u, scrollParent: _, eventPreventDefault: p, onTouchStart: f, onTouchMove: v, onTouchEnd: y, getScrollParent: g, handlePositionOnTouchEnd: m, collapse: C, DsSpinner: Vt };
  }
});
var Uu = function() {
  var t = this, e = t._self._c, n = t._self._setupProxy;
  return e("div", { staticClass: "ds-pull-refresh" }, [e("div", { staticClass: "ds-pull-refresh__spinner", style: { transform: `rotate(${Math.min(n.touchOffsetY, 40) * 2.5}deg)` } }, [e(n.DsSpinner, { attrs: { "is-spinning": !n.isOnTouch && n.touchOffsetY > 0, size: "s", color: t.color } })], 1), e("div", { ref: "bodyRef", staticClass: "ds-pull-refresh__body", class: {
    "ds-pull-refresh__body--on-touch": n.isOnTouch
  }, style: { transform: `translateY(${n.touchOffsetY}px) translate3d(0, 0, 0)` }, on: { touchstart: n.onTouchStart, touchmove: n.onTouchMove, touchend: n.onTouchEnd } }, [t._t("default")], 2)]);
}, Yu = [], qu = /* @__PURE__ */ d(
  ju,
  Uu,
  Yu,
  !1,
  null,
  null,
  null,
  null
);
const o_ = qu.exports;
export {
  Wt as CHIPS_GROUP_PROVIDER,
  Ht as CONTAINER_PROPS,
  Ku as DsAccordion,
  ed as DsAccordionItem,
  sd as DsAlert,
  nd as DsAvatarBadge,
  od as DsAvatarIcon,
  rd as DsAvatarImage,
  ad as DsAvatarLetter,
  po as DsBackdrop,
  id as DsBadgeProduct,
  So as DsButton,
  Ao as DsButtonBar,
  ud as DsCard,
  n_ as DsCarousel,
  Qe as DsCell,
  dd as DsCellProgress,
  _d as DsChart,
  fd as DsCheckbox,
  pd as DsChip,
  vd as DsChipFilter,
  pr as DsChipFilterColorItem,
  md as DsChipImage,
  hd as DsChipSuggest,
  gd as DsChipsGroup,
  S as DsContainer,
  Er as DsDivider,
  $d as DsDropdown,
  bd as DsExpand,
  Ue as DsExpandTransition,
  ie as DsFadeTransition,
  R as DsIcon,
  yd as DsIconBack,
  de as DsIllustration,
  xd as DsInformer,
  Cd as DsInlineStatus,
  Pa as DsInput,
  wd as DsInputMasked,
  Qa as DsInputSearch,
  kd as DsIsland,
  Dd as DsIslandsContainer,
  fi as DsLayout,
  Sd as DsLinkCell,
  wi as DsLinkDefault,
  Td as DsLoader,
  ca as DsLottieAnimation,
  Qd as DsModal,
  Ii as DsNavBar,
  Mi as DsNavButton,
  ue as DsOverlay,
  Qu as DsPageTransition,
  ce as DsPortal,
  Yo as DsProgressBar,
  Rd as DsPullController,
  o_ as DsPullRefresh,
  za as DsRadioButton,
  Bd as DsResultBanner,
  Od as DsSearchBar,
  Ad as DsSearchBarButton,
  Ed as DsSegmentSpacer,
  Id as DsSegmentedControl,
  Pd as DsSegmentedControlItem,
  s_ as DsSkeletonCell,
  e_ as DsSkeletonText,
  t_ as DsSkeletonTitle,
  Ju as DsSlideTransition,
  Kd as DsSnackbar,
  Vt as DsSpinner,
  Ld as DsSpinnerModal,
  Dt as DsStatusIcon,
  Md as DsStepNumber,
  Hd as DsStepProgress,
  Fd as DsStepper,
  zd as DsStepperNumber,
  Nd as DsStepperProgress,
  jd as DsTable,
  Ud as DsTableCell,
  Yd as DsTableColumn,
  qd as DsTableHeader,
  Zd as DsTableRow,
  wc as DsTitle,
  Xd as DsToggle,
  Gd as DsTooltip,
  Jd as DsUnavailable,
  os as INPUT_EMITS,
  ns as INPUT_PROPS,
  as as INPUT_SEARCH_EMITS,
  rs as INPUT_SEARCH_PROPS,
  ts as PROGRESS_BAR_PROPS,
  qe as TransitionInjectionKey,
  cd as buttonSizes,
  ld as buttonVariants,
  Vd as tableSizes,
  Wd as tableTextAlign,
  td as usePageTransition
};
